(function () {
// import { tns } from 'tiny-slider';
function $2ebe0d2e21d2eed1$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $e63983a9d029a17a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e63983a9d029a17a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e63983a9d029a17a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e63983a9d029a17a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $e63983a9d029a17a$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $e63983a9d029a17a$var$CREATED = 1;
var $e63983a9d029a17a$var$MOUNTED = 2;
var $e63983a9d029a17a$var$IDLE = 3;
var $e63983a9d029a17a$var$MOVING = 4;
var $e63983a9d029a17a$var$SCROLLING = 5;
var $e63983a9d029a17a$var$DRAGGING = 6;
var $e63983a9d029a17a$var$DESTROYED = 7;
var $e63983a9d029a17a$var$STATES = {
    CREATED: $e63983a9d029a17a$var$CREATED,
    MOUNTED: $e63983a9d029a17a$var$MOUNTED,
    IDLE: $e63983a9d029a17a$var$IDLE,
    MOVING: $e63983a9d029a17a$var$MOVING,
    SCROLLING: $e63983a9d029a17a$var$SCROLLING,
    DRAGGING: $e63983a9d029a17a$var$DRAGGING,
    DESTROYED: $e63983a9d029a17a$var$DESTROYED
};
function $e63983a9d029a17a$var$empty(array) {
    array.length = 0;
}
function $e63983a9d029a17a$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $e63983a9d029a17a$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($e63983a9d029a17a$var$slice(arguments, 1)));
}
var $e63983a9d029a17a$var$nextTick = setTimeout;
var $e63983a9d029a17a$var$noop = function noop() {};
function $e63983a9d029a17a$var$raf(func) {
    return requestAnimationFrame(func);
}
function $e63983a9d029a17a$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $2ebe0d2e21d2eed1$export$5f0017c582d45a2d)(subject)) === type;
}
function $e63983a9d029a17a$var$isObject(subject) {
    return !$e63983a9d029a17a$var$isNull(subject) && $e63983a9d029a17a$var$typeOf("object", subject);
}
var $e63983a9d029a17a$var$isArray = Array.isArray;
var $e63983a9d029a17a$var$isFunction = $e63983a9d029a17a$var$apply($e63983a9d029a17a$var$typeOf, "function");
var $e63983a9d029a17a$var$isString = $e63983a9d029a17a$var$apply($e63983a9d029a17a$var$typeOf, "string");
var $e63983a9d029a17a$var$isUndefined = $e63983a9d029a17a$var$apply($e63983a9d029a17a$var$typeOf, "undefined");
function $e63983a9d029a17a$var$isNull(subject) {
    return subject === null;
}
function $e63983a9d029a17a$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $e63983a9d029a17a$var$toArray(value) {
    return $e63983a9d029a17a$var$isArray(value) ? value : [
        value
    ];
}
function $e63983a9d029a17a$var$forEach(values, iteratee) {
    $e63983a9d029a17a$var$toArray(values).forEach(iteratee);
}
function $e63983a9d029a17a$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $e63983a9d029a17a$var$push(array, items) {
    array.push.apply(array, $e63983a9d029a17a$var$toArray(items));
    return array;
}
function $e63983a9d029a17a$var$toggleClass(elm, classes, add) {
    if (elm) $e63983a9d029a17a$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $e63983a9d029a17a$var$addClass(elm, classes) {
    $e63983a9d029a17a$var$toggleClass(elm, $e63983a9d029a17a$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $e63983a9d029a17a$var$append(parent, children) {
    $e63983a9d029a17a$var$forEach(children, parent.appendChild.bind(parent));
}
function $e63983a9d029a17a$var$before(nodes, ref) {
    $e63983a9d029a17a$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $e63983a9d029a17a$var$matches(elm, selector) {
    return $e63983a9d029a17a$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $e63983a9d029a17a$var$children(parent, selector) {
    var children2 = parent ? $e63983a9d029a17a$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $e63983a9d029a17a$var$matches(child, selector);
    }) : children2;
}
function $e63983a9d029a17a$var$child(parent, selector) {
    return selector ? $e63983a9d029a17a$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $e63983a9d029a17a$var$ownKeys = Object.keys;
function $e63983a9d029a17a$var$forOwn(object, iteratee, right) {
    if (object) (right ? $e63983a9d029a17a$var$ownKeys(object).reverse() : $e63983a9d029a17a$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $e63983a9d029a17a$var$assign(object) {
    $e63983a9d029a17a$var$slice(arguments, 1).forEach(function(source) {
        $e63983a9d029a17a$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $e63983a9d029a17a$var$merge(object) {
    $e63983a9d029a17a$var$slice(arguments, 1).forEach(function(source) {
        $e63983a9d029a17a$var$forOwn(source, function(value, key) {
            if ($e63983a9d029a17a$var$isArray(value)) object[key] = value.slice();
            else if ($e63983a9d029a17a$var$isObject(value)) object[key] = $e63983a9d029a17a$var$merge({}, $e63983a9d029a17a$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $e63983a9d029a17a$var$omit(object, keys) {
    $e63983a9d029a17a$var$forEach(keys || $e63983a9d029a17a$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $e63983a9d029a17a$var$removeAttribute(elms, attrs) {
    $e63983a9d029a17a$var$forEach(elms, function(elm) {
        $e63983a9d029a17a$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $e63983a9d029a17a$var$setAttribute(elms, attrs, value) {
    if ($e63983a9d029a17a$var$isObject(attrs)) $e63983a9d029a17a$var$forOwn(attrs, function(value2, name) {
        $e63983a9d029a17a$var$setAttribute(elms, name, value2);
    });
    else $e63983a9d029a17a$var$forEach(elms, function(elm) {
        $e63983a9d029a17a$var$isNull(value) || value === "" ? $e63983a9d029a17a$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $e63983a9d029a17a$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $e63983a9d029a17a$var$isString(attrs) ? $e63983a9d029a17a$var$addClass(elm, attrs) : $e63983a9d029a17a$var$setAttribute(elm, attrs);
    parent && $e63983a9d029a17a$var$append(parent, elm);
    return elm;
}
function $e63983a9d029a17a$var$style(elm, prop, value) {
    if ($e63983a9d029a17a$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$e63983a9d029a17a$var$isNull(value)) elm.style[prop] = "" + value;
}
function $e63983a9d029a17a$var$display(elm, display2) {
    $e63983a9d029a17a$var$style(elm, "display", display2);
}
function $e63983a9d029a17a$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $e63983a9d029a17a$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $e63983a9d029a17a$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $e63983a9d029a17a$var$rect(target) {
    return target.getBoundingClientRect();
}
function $e63983a9d029a17a$var$remove(nodes) {
    $e63983a9d029a17a$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $e63983a9d029a17a$var$parseHtml(html) {
    return $e63983a9d029a17a$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $e63983a9d029a17a$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $e63983a9d029a17a$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $e63983a9d029a17a$var$queryAll(parent, selector) {
    return selector ? $e63983a9d029a17a$var$slice(parent.querySelectorAll(selector)) : [];
}
function $e63983a9d029a17a$var$removeClass(elm, classes) {
    $e63983a9d029a17a$var$toggleClass(elm, classes, false);
}
function $e63983a9d029a17a$var$timeOf(e) {
    return e.timeStamp;
}
function $e63983a9d029a17a$var$unit(value) {
    return $e63983a9d029a17a$var$isString(value) ? value : value ? value + "px" : "";
}
var $e63983a9d029a17a$var$PROJECT_CODE = "splide";
var $e63983a9d029a17a$var$DATA_ATTRIBUTE = "data-" + $e63983a9d029a17a$var$PROJECT_CODE;
function $e63983a9d029a17a$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $e63983a9d029a17a$var$PROJECT_CODE + "] " + (message || ""));
}
var $e63983a9d029a17a$var$min = Math.min, $e63983a9d029a17a$var$max = Math.max, $e63983a9d029a17a$var$floor = Math.floor, $e63983a9d029a17a$var$ceil = Math.ceil, $e63983a9d029a17a$var$abs = Math.abs;
function $e63983a9d029a17a$var$approximatelyEqual(x, y, epsilon) {
    return $e63983a9d029a17a$var$abs(x - y) < epsilon;
}
function $e63983a9d029a17a$var$between(number, x, y, exclusive) {
    var minimum = $e63983a9d029a17a$var$min(x, y);
    var maximum = $e63983a9d029a17a$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $e63983a9d029a17a$var$clamp(number, x, y) {
    var minimum = $e63983a9d029a17a$var$min(x, y);
    var maximum = $e63983a9d029a17a$var$max(x, y);
    return $e63983a9d029a17a$var$min($e63983a9d029a17a$var$max(minimum, number), maximum);
}
function $e63983a9d029a17a$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $e63983a9d029a17a$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $e63983a9d029a17a$var$format(string, replacements) {
    $e63983a9d029a17a$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $e63983a9d029a17a$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $e63983a9d029a17a$var$ids = {};
function $e63983a9d029a17a$var$uniqueId(prefix) {
    return "" + prefix + $e63983a9d029a17a$var$pad($e63983a9d029a17a$var$ids[prefix] = ($e63983a9d029a17a$var$ids[prefix] || 0) + 1);
}
function $e63983a9d029a17a$export$c473e36ef1bda729() {
    var bind = function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    };
    var unbind = function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    };
    var dispatch = function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    };
    var forEachEvent = function forEachEvent(targets, events, iteratee) {
        $e63983a9d029a17a$var$forEach(targets, function(target) {
            target && $e63983a9d029a17a$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    };
    var destroy = function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $e63983a9d029a17a$var$empty(listeners);
    };
    var listeners = [];
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $e63983a9d029a17a$export$d300dc1a2634364b = "mounted";
var $e63983a9d029a17a$export$d8dac49b4532735a = "ready";
var $e63983a9d029a17a$export$2aa493d7c3275167 = "move";
var $e63983a9d029a17a$export$fe5802204b967f0d = "moved";
var $e63983a9d029a17a$export$5adb665701eda1ce = "click";
var $e63983a9d029a17a$export$92e3eae133acac4c = "active";
var $e63983a9d029a17a$export$6bcbb81035c12cea = "inactive";
var $e63983a9d029a17a$export$6a5b3445e4066a53 = "visible";
var $e63983a9d029a17a$export$8c5c7a21d54563e9 = "hidden";
var $e63983a9d029a17a$export$7f4701ac5e05e39f = "refresh";
var $e63983a9d029a17a$export$db40ab7c0855fa5c = "updated";
var $e63983a9d029a17a$export$7e019dae5103a285 = "resize";
var $e63983a9d029a17a$export$d637eba1e9e28482 = "resized";
var $e63983a9d029a17a$export$e84bf5065c9087ac = "drag";
var $e63983a9d029a17a$export$8e9f636d2c722196 = "dragging";
var $e63983a9d029a17a$export$90ea576bd3fdeb60 = "dragged";
var $e63983a9d029a17a$export$49801896908b5e33 = "scroll";
var $e63983a9d029a17a$export$ff8164bff3202b9 = "scrolled";
var $e63983a9d029a17a$export$6cbac5b662a31e1b = "overflow";
var $e63983a9d029a17a$export$88c4cf7419e470cd = "destroy";
var $e63983a9d029a17a$export$8647f6b043e04e9d = "arrows:mounted";
var $e63983a9d029a17a$export$d467f9343b961f75 = "arrows:updated";
var $e63983a9d029a17a$export$bf89a4e4349c9778 = "pagination:mounted";
var $e63983a9d029a17a$export$eb2019082ed6de0b = "pagination:updated";
var $e63983a9d029a17a$export$84015c33508f94ec = "navigation:mounted";
var $e63983a9d029a17a$export$23663268a31b79e2 = "autoplay:play";
var $e63983a9d029a17a$export$185723258309b608 = "autoplay:playing";
var $e63983a9d029a17a$export$16a1e4f3d0368265 = "autoplay:pause";
var $e63983a9d029a17a$export$9f64346e17f0ec8e = "lazyload:loaded";
var $e63983a9d029a17a$export$6d5af59619d10e6a = "sk";
var $e63983a9d029a17a$export$f0af896383d5adff = "sh";
var $e63983a9d029a17a$export$28dea85f216954dc = "ei";
function $e63983a9d029a17a$export$f188226459c8a3ff(Splide2) {
    var on = function on(events, callback) {
        binder.bind(bus, $e63983a9d029a17a$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $e63983a9d029a17a$var$isArray(e.detail) ? e.detail : []);
        });
    };
    var emit = function emit(event) {
        binder.dispatch(bus, event, $e63983a9d029a17a$var$slice(arguments, 1));
    };
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $e63983a9d029a17a$export$c473e36ef1bda729();
    if (Splide2) Splide2.event.on($e63983a9d029a17a$export$88c4cf7419e470cd, binder.destroy);
    return $e63983a9d029a17a$var$assign(binder, {
        bus: bus,
        on: on,
        off: $e63983a9d029a17a$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $e63983a9d029a17a$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var start = function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $e63983a9d029a17a$var$raf(update);
    };
    var pause = function pause() {
        paused = true;
    };
    var rewind = function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    };
    var cancel = function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    };
    var set = function set(time) {
        interval = time;
    };
    var isPaused = function isPaused() {
        return paused;
    };
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $e63983a9d029a17a$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $e63983a9d029a17a$var$raf(update);
        }
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $e63983a9d029a17a$export$7254cc27399e90bd(initialState) {
    var set = function set(value) {
        state = value;
    };
    var is = function is(states) {
        return $e63983a9d029a17a$var$includes($e63983a9d029a17a$var$toArray(states), state);
    };
    var state = initialState;
    return {
        set: set,
        is: is
    };
}
function $e63983a9d029a17a$export$efff0f5979573c99(func, duration) {
    var interval = $e63983a9d029a17a$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $e63983a9d029a17a$var$Media(Splide2, Components2, options) {
    var setup = function setup() {
        var isMin = options.mediaQuery === "min";
        $e63983a9d029a17a$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $e63983a9d029a17a$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    };
    var destroy = function destroy(completely) {
        if (completely) binder.destroy();
    };
    var register = function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    };
    var update = function update() {
        var destroyed = state.is($e63983a9d029a17a$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $e63983a9d029a17a$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $e63983a9d029a17a$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    };
    var reduce = function reduce(enable) {
        if (matchMedia($e63983a9d029a17a$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $e63983a9d029a17a$var$merge(options, reducedMotion) : $e63983a9d029a17a$var$omit(options, $e63983a9d029a17a$var$ownKeys(reducedMotion));
    };
    var set = function set(opts, base, notify) {
        $e63983a9d029a17a$var$merge(options, opts);
        base && $e63983a9d029a17a$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($e63983a9d029a17a$var$CREATED)) Splide2.emit($e63983a9d029a17a$export$db40ab7c0855fa5c, options);
    };
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $e63983a9d029a17a$export$c473e36ef1bda729();
    var queries = [];
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $e63983a9d029a17a$var$ARROW = "Arrow";
var $e63983a9d029a17a$var$ARROW_LEFT = $e63983a9d029a17a$var$ARROW + "Left";
var $e63983a9d029a17a$var$ARROW_RIGHT = $e63983a9d029a17a$var$ARROW + "Right";
var $e63983a9d029a17a$var$ARROW_UP = $e63983a9d029a17a$var$ARROW + "Up";
var $e63983a9d029a17a$var$ARROW_DOWN = $e63983a9d029a17a$var$ARROW + "Down";
var $e63983a9d029a17a$export$373e92e0788ff06e = "ltr";
var $e63983a9d029a17a$export$850f7749a2909601 = "rtl";
var $e63983a9d029a17a$export$97170d9824b89709 = "ttb";
var $e63983a9d029a17a$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $e63983a9d029a17a$var$ARROW_UP,
        $e63983a9d029a17a$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $e63983a9d029a17a$var$ARROW_DOWN,
        $e63983a9d029a17a$var$ARROW_LEFT
    ]
};
function $e63983a9d029a17a$var$Direction(Splide2, Components2, options) {
    var resolve = function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $e63983a9d029a17a$export$850f7749a2909601 && !axisOnly ? 1 : direction === $e63983a9d029a17a$export$97170d9824b89709 ? 0 : -1;
        return $e63983a9d029a17a$var$ORIENTATION_MAP[prop] && $e63983a9d029a17a$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $e63983a9d029a17a$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    };
    var orient = function orient(value) {
        return value * (options.direction === $e63983a9d029a17a$export$850f7749a2909601 ? 1 : -1);
    };
    return {
        resolve: resolve,
        orient: orient
    };
}
var $e63983a9d029a17a$var$ROLE = "role";
var $e63983a9d029a17a$var$TAB_INDEX = "tabindex";
var $e63983a9d029a17a$var$DISABLED = "disabled";
var $e63983a9d029a17a$var$ARIA_PREFIX = "aria-";
var $e63983a9d029a17a$var$ARIA_CONTROLS = $e63983a9d029a17a$var$ARIA_PREFIX + "controls";
var $e63983a9d029a17a$var$ARIA_CURRENT = $e63983a9d029a17a$var$ARIA_PREFIX + "current";
var $e63983a9d029a17a$var$ARIA_SELECTED = $e63983a9d029a17a$var$ARIA_PREFIX + "selected";
var $e63983a9d029a17a$var$ARIA_LABEL = $e63983a9d029a17a$var$ARIA_PREFIX + "label";
var $e63983a9d029a17a$var$ARIA_LABELLEDBY = $e63983a9d029a17a$var$ARIA_PREFIX + "labelledby";
var $e63983a9d029a17a$var$ARIA_HIDDEN = $e63983a9d029a17a$var$ARIA_PREFIX + "hidden";
var $e63983a9d029a17a$var$ARIA_ORIENTATION = $e63983a9d029a17a$var$ARIA_PREFIX + "orientation";
var $e63983a9d029a17a$var$ARIA_ROLEDESCRIPTION = $e63983a9d029a17a$var$ARIA_PREFIX + "roledescription";
var $e63983a9d029a17a$var$ARIA_LIVE = $e63983a9d029a17a$var$ARIA_PREFIX + "live";
var $e63983a9d029a17a$var$ARIA_BUSY = $e63983a9d029a17a$var$ARIA_PREFIX + "busy";
var $e63983a9d029a17a$var$ARIA_ATOMIC = $e63983a9d029a17a$var$ARIA_PREFIX + "atomic";
var $e63983a9d029a17a$var$ALL_ATTRIBUTES = [
    $e63983a9d029a17a$var$ROLE,
    $e63983a9d029a17a$var$TAB_INDEX,
    $e63983a9d029a17a$var$DISABLED,
    $e63983a9d029a17a$var$ARIA_CONTROLS,
    $e63983a9d029a17a$var$ARIA_CURRENT,
    $e63983a9d029a17a$var$ARIA_LABEL,
    $e63983a9d029a17a$var$ARIA_LABELLEDBY,
    $e63983a9d029a17a$var$ARIA_HIDDEN,
    $e63983a9d029a17a$var$ARIA_ORIENTATION,
    $e63983a9d029a17a$var$ARIA_ROLEDESCRIPTION
];
var $e63983a9d029a17a$var$CLASS_PREFIX = $e63983a9d029a17a$var$PROJECT_CODE + "__";
var $e63983a9d029a17a$var$STATUS_CLASS_PREFIX = "is-";
var $e63983a9d029a17a$export$93b21159ad85c843 = $e63983a9d029a17a$var$PROJECT_CODE;
var $e63983a9d029a17a$export$7738b09ac0a98952 = $e63983a9d029a17a$var$CLASS_PREFIX + "track";
var $e63983a9d029a17a$export$19cc2a5451235cae = $e63983a9d029a17a$var$CLASS_PREFIX + "list";
var $e63983a9d029a17a$export$8d922915837a38d3 = $e63983a9d029a17a$var$CLASS_PREFIX + "slide";
var $e63983a9d029a17a$export$2c1ba4a4f1aa4947 = $e63983a9d029a17a$export$8d922915837a38d3 + "--clone";
var $e63983a9d029a17a$export$e9ba7e444ba60a12 = $e63983a9d029a17a$export$8d922915837a38d3 + "__container";
var $e63983a9d029a17a$export$a26cbd955fecf11e = $e63983a9d029a17a$var$CLASS_PREFIX + "arrows";
var $e63983a9d029a17a$export$516e7d18e13a2dca = $e63983a9d029a17a$var$CLASS_PREFIX + "arrow";
var $e63983a9d029a17a$export$58ea3db24c33b76 = $e63983a9d029a17a$export$516e7d18e13a2dca + "--prev";
var $e63983a9d029a17a$export$4885afd7098a65c2 = $e63983a9d029a17a$export$516e7d18e13a2dca + "--next";
var $e63983a9d029a17a$export$cbf8e5a0ab95eda3 = $e63983a9d029a17a$var$CLASS_PREFIX + "pagination";
var $e63983a9d029a17a$export$52f2cca6a5eee805 = $e63983a9d029a17a$export$cbf8e5a0ab95eda3 + "__page";
var $e63983a9d029a17a$export$4c82dc32b1c4ace5 = $e63983a9d029a17a$var$CLASS_PREFIX + "progress";
var $e63983a9d029a17a$export$2c9b091c749f4409 = $e63983a9d029a17a$export$4c82dc32b1c4ace5 + "__bar";
var $e63983a9d029a17a$export$a29701deef84b825 = $e63983a9d029a17a$var$CLASS_PREFIX + "toggle";
var $e63983a9d029a17a$export$d9d247d51b430dbb = $e63983a9d029a17a$export$a29701deef84b825 + "__play";
var $e63983a9d029a17a$export$3529f201a419925b = $e63983a9d029a17a$export$a29701deef84b825 + "__pause";
var $e63983a9d029a17a$export$3e5381ee3fab8374 = $e63983a9d029a17a$var$CLASS_PREFIX + "spinner";
var $e63983a9d029a17a$export$bb78d7c200da8960 = $e63983a9d029a17a$var$CLASS_PREFIX + "sr";
var $e63983a9d029a17a$export$7761661e2d5b9388 = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "initialized";
var $e63983a9d029a17a$export$72d36ecf3758cb4b = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "active";
var $e63983a9d029a17a$export$e423ac4972f5e196 = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "prev";
var $e63983a9d029a17a$export$457a2d20827a2779 = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "next";
var $e63983a9d029a17a$export$53ca4621bbab9a = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "visible";
var $e63983a9d029a17a$export$d22ec4ccb7996ba2 = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "loading";
var $e63983a9d029a17a$export$b6f202a162a09100 = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "focus-in";
var $e63983a9d029a17a$export$cd908cd1dd625e29 = $e63983a9d029a17a$var$STATUS_CLASS_PREFIX + "overflow";
var $e63983a9d029a17a$export$49f9eaea10ebf193 = [
    $e63983a9d029a17a$export$72d36ecf3758cb4b,
    $e63983a9d029a17a$export$53ca4621bbab9a,
    $e63983a9d029a17a$export$e423ac4972f5e196,
    $e63983a9d029a17a$export$457a2d20827a2779,
    $e63983a9d029a17a$export$d22ec4ccb7996ba2,
    $e63983a9d029a17a$export$b6f202a162a09100,
    $e63983a9d029a17a$export$cd908cd1dd625e29
];
var $e63983a9d029a17a$export$ba41d43e4a419565 = {
    slide: $e63983a9d029a17a$export$8d922915837a38d3,
    clone: $e63983a9d029a17a$export$2c1ba4a4f1aa4947,
    arrows: $e63983a9d029a17a$export$a26cbd955fecf11e,
    arrow: $e63983a9d029a17a$export$516e7d18e13a2dca,
    prev: $e63983a9d029a17a$export$58ea3db24c33b76,
    next: $e63983a9d029a17a$export$4885afd7098a65c2,
    pagination: $e63983a9d029a17a$export$cbf8e5a0ab95eda3,
    page: $e63983a9d029a17a$export$52f2cca6a5eee805,
    spinner: $e63983a9d029a17a$export$3e5381ee3fab8374
};
function $e63983a9d029a17a$var$closest(from, selector) {
    if ($e63983a9d029a17a$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($e63983a9d029a17a$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $e63983a9d029a17a$var$FRICTION = 5;
var $e63983a9d029a17a$var$LOG_INTERVAL = 200;
var $e63983a9d029a17a$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $e63983a9d029a17a$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $e63983a9d029a17a$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $e63983a9d029a17a$var$Elements(Splide2, Components2, options) {
    var setup = function setup() {
        collect();
        init();
        update();
    };
    var mount = function mount() {
        on($e63983a9d029a17a$export$7f4701ac5e05e39f, destroy);
        on($e63983a9d029a17a$export$7f4701ac5e05e39f, setup);
        on($e63983a9d029a17a$export$db40ab7c0855fa5c, update);
        bind(document, $e63983a9d029a17a$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $e63983a9d029a17a$var$toggleClass(root, $e63983a9d029a17a$export$b6f202a162a09100, !!isUsingKey);
        });
    };
    var destroy = function destroy(completely) {
        var attrs = $e63983a9d029a17a$var$ALL_ATTRIBUTES.concat("style");
        $e63983a9d029a17a$var$empty(slides);
        $e63983a9d029a17a$var$removeClass(root, rootClasses);
        $e63983a9d029a17a$var$removeClass(track, trackClasses);
        $e63983a9d029a17a$var$removeAttribute([
            track,
            list
        ], attrs);
        $e63983a9d029a17a$var$removeAttribute(root, completely ? attrs : [
            "style",
            $e63983a9d029a17a$var$ARIA_ROLEDESCRIPTION
        ]);
    };
    var update = function update() {
        $e63983a9d029a17a$var$removeClass(root, rootClasses);
        $e63983a9d029a17a$var$removeClass(track, trackClasses);
        rootClasses = getClasses($e63983a9d029a17a$export$93b21159ad85c843);
        trackClasses = getClasses($e63983a9d029a17a$export$7738b09ac0a98952);
        $e63983a9d029a17a$var$addClass(root, rootClasses);
        $e63983a9d029a17a$var$addClass(track, trackClasses);
        $e63983a9d029a17a$var$setAttribute(root, $e63983a9d029a17a$var$ARIA_LABEL, options.label);
        $e63983a9d029a17a$var$setAttribute(root, $e63983a9d029a17a$var$ARIA_LABELLEDBY, options.labelledby);
    };
    var collect = function collect() {
        track = find("." + $e63983a9d029a17a$export$7738b09ac0a98952);
        list = $e63983a9d029a17a$var$child(track, "." + $e63983a9d029a17a$export$19cc2a5451235cae);
        $e63983a9d029a17a$var$assert(track && list, "A track/list element is missing.");
        $e63983a9d029a17a$var$push(slides, $e63983a9d029a17a$var$children(list, "." + $e63983a9d029a17a$export$8d922915837a38d3 + ":not(." + $e63983a9d029a17a$export$2c1ba4a4f1aa4947 + ")"));
        $e63983a9d029a17a$var$forOwn({
            arrows: $e63983a9d029a17a$export$a26cbd955fecf11e,
            pagination: $e63983a9d029a17a$export$cbf8e5a0ab95eda3,
            prev: $e63983a9d029a17a$export$58ea3db24c33b76,
            next: $e63983a9d029a17a$export$4885afd7098a65c2,
            bar: $e63983a9d029a17a$export$2c9b091c749f4409,
            toggle: $e63983a9d029a17a$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $e63983a9d029a17a$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    };
    var init = function init() {
        var id = root.id || $e63983a9d029a17a$var$uniqueId($e63983a9d029a17a$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$e63983a9d029a17a$var$getAttribute(root, $e63983a9d029a17a$var$ROLE) && root.tagName !== "SECTION" && role) $e63983a9d029a17a$var$setAttribute(root, $e63983a9d029a17a$var$ROLE, role);
        $e63983a9d029a17a$var$setAttribute(root, $e63983a9d029a17a$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $e63983a9d029a17a$var$setAttribute(list, $e63983a9d029a17a$var$ROLE, "presentation");
    };
    var find = function find(selector) {
        var elm = $e63983a9d029a17a$var$query(root, selector);
        return elm && $e63983a9d029a17a$var$closest(elm, "." + $e63983a9d029a17a$export$93b21159ad85c843) === root ? elm : void 0;
    };
    var getClasses = function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $e63983a9d029a17a$export$93b21159ad85c843 && $e63983a9d029a17a$export$72d36ecf3758cb4b
        ];
    };
    var _EventInterface = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    return $e63983a9d029a17a$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $e63983a9d029a17a$export$e5a58a5ee5b54c22 = "slide";
var $e63983a9d029a17a$export$f42383286ed1223d = "loop";
var $e63983a9d029a17a$export$742b62a5690c060 = "fade";
function $e63983a9d029a17a$var$Slide$1(Splide2, index, slideIndex, slide) {
    var mount = function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $e63983a9d029a17a$var$pad(index + 1);
            $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ROLE, pagination ? "tabpanel" : "group");
            $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ARIA_LABEL, label || $e63983a9d029a17a$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    };
    var listen = function listen() {
        bind(slide, "click", $e63983a9d029a17a$var$apply(emit, $e63983a9d029a17a$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $e63983a9d029a17a$var$apply(emit, $e63983a9d029a17a$export$6d5af59619d10e6a, self));
        on([
            $e63983a9d029a17a$export$fe5802204b967f0d,
            $e63983a9d029a17a$export$f0af896383d5adff,
            $e63983a9d029a17a$export$ff8164bff3202b9
        ], update);
        on($e63983a9d029a17a$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($e63983a9d029a17a$export$2aa493d7c3275167, onMove);
    };
    var destroy = function destroy() {
        destroyed = true;
        event.destroy();
        $e63983a9d029a17a$var$removeClass(slide, $e63983a9d029a17a$export$49f9eaea10ebf193);
        $e63983a9d029a17a$var$removeAttribute(slide, $e63983a9d029a17a$var$ALL_ATTRIBUTES);
        $e63983a9d029a17a$var$setAttribute(slide, "style", styles);
        $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ARIA_LABEL, label || "");
    };
    var initNavigation = function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ARIA_LABEL, $e63983a9d029a17a$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ARIA_CONTROLS, controls);
        $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $e63983a9d029a17a$var$removeAttribute(slide, $e63983a9d029a17a$var$ARIA_ROLEDESCRIPTION);
    };
    var onMove = function onMove() {
        if (!destroyed) update();
    };
    var update = function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $e63983a9d029a17a$var$toggleClass(slide, $e63983a9d029a17a$export$e423ac4972f5e196, index === curr - 1);
            $e63983a9d029a17a$var$toggleClass(slide, $e63983a9d029a17a$export$457a2d20827a2779, index === curr + 1);
        }
    };
    var updateActivity = function updateActivity() {
        var active = isActive();
        if (active !== $e63983a9d029a17a$var$hasClass(slide, $e63983a9d029a17a$export$72d36ecf3758cb4b)) {
            $e63983a9d029a17a$var$toggleClass(slide, $e63983a9d029a17a$export$72d36ecf3758cb4b, active);
            $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $e63983a9d029a17a$export$92e3eae133acac4c : $e63983a9d029a17a$export$6bcbb81035c12cea, self);
        }
    };
    var updateVisibility = function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $e63983a9d029a17a$var$MOVING,
            $e63983a9d029a17a$var$SCROLLING
        ])) $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$ARIA_HIDDEN, hidden || "");
        $e63983a9d029a17a$var$setAttribute($e63983a9d029a17a$var$queryAll(slide, options.focusableNodes || ""), $e63983a9d029a17a$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $e63983a9d029a17a$var$setAttribute(slide, $e63983a9d029a17a$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $e63983a9d029a17a$var$hasClass(slide, $e63983a9d029a17a$export$53ca4621bbab9a)) {
            $e63983a9d029a17a$var$toggleClass(slide, $e63983a9d029a17a$export$53ca4621bbab9a, visible);
            emit(visible ? $e63983a9d029a17a$export$6a5b3445e4066a53 : $e63983a9d029a17a$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $e63983a9d029a17a$var$focus(Slide2.slide);
        }
    };
    var style$1 = function style$1(prop, value, useContainer) {
        $e63983a9d029a17a$var$style(useContainer && container || slide, prop, value);
    };
    var isActive = function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    };
    var isVisible = function isVisible() {
        if (Splide2.is($e63983a9d029a17a$export$742b62a5690c060)) return isActive();
        var trackRect = $e63983a9d029a17a$var$rect(Components.Elements.track);
        var slideRect = $e63983a9d029a17a$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $e63983a9d029a17a$var$floor(trackRect[left]) <= $e63983a9d029a17a$var$ceil(slideRect[left]) && $e63983a9d029a17a$var$floor(slideRect[right]) <= $e63983a9d029a17a$var$ceil(trackRect[right]);
    };
    var isWithin = function isWithin(from, distance) {
        var diff = $e63983a9d029a17a$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($e63983a9d029a17a$export$f42383286ed1223d))) diff = $e63983a9d029a17a$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    };
    var event = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $e63983a9d029a17a$var$getAttribute(slide, "style");
    var label = $e63983a9d029a17a$var$getAttribute(slide, $e63983a9d029a17a$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $e63983a9d029a17a$var$child(slide, "." + $e63983a9d029a17a$export$e9ba7e444ba60a12);
    var destroyed;
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $e63983a9d029a17a$var$Slides(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($e63983a9d029a17a$export$7f4701ac5e05e39f, destroy);
        on($e63983a9d029a17a$export$7f4701ac5e05e39f, init);
    };
    var init = function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    };
    var destroy = function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $e63983a9d029a17a$var$empty(Slides2);
    };
    var update = function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    };
    var register = function register(slide, index, slideIndex) {
        var object = $e63983a9d029a17a$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    };
    var get = function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    };
    var getIn = function getIn(page) {
        var _$Controller = Components2.Controller;
        var index = _$Controller.toIndex(page);
        var max = _$Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $e63983a9d029a17a$var$between(Slide2.index, index, index + max - 1);
        });
    };
    var getAt = function getAt(index) {
        return filter(index)[0];
    };
    var add = function add(items, index) {
        $e63983a9d029a17a$var$forEach(items, function(slide) {
            if ($e63983a9d029a17a$var$isString(slide)) slide = $e63983a9d029a17a$var$parseHtml(slide);
            if ($e63983a9d029a17a$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $e63983a9d029a17a$var$before(slide, ref) : $e63983a9d029a17a$var$append(list, slide);
                $e63983a9d029a17a$var$addClass(slide, options.classes.slide);
                observeImages(slide, $e63983a9d029a17a$var$apply(emit, $e63983a9d029a17a$export$7e019dae5103a285));
            }
        });
        emit($e63983a9d029a17a$export$7f4701ac5e05e39f);
    };
    var remove$1 = function remove$1(matcher) {
        $e63983a9d029a17a$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($e63983a9d029a17a$export$7f4701ac5e05e39f);
    };
    var forEach$1 = function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    };
    var filter = function filter(matcher) {
        return Slides2.filter($e63983a9d029a17a$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $e63983a9d029a17a$var$isString(matcher) ? $e63983a9d029a17a$var$matches(Slide2.slide, matcher) : $e63983a9d029a17a$var$includes($e63983a9d029a17a$var$toArray(matcher), Slide2.index);
        });
    };
    var style = function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    };
    var observeImages = function observeImages(elm, callback) {
        var images = $e63983a9d029a17a$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    };
    var getLength = function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    };
    var isEnough = function isEnough() {
        return Slides2.length > options.perPage;
    };
    var _EventInterface2 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $e63983a9d029a17a$var$Layout(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        bind(window, "resize load", $e63983a9d029a17a$export$efff0f5979573c99($e63983a9d029a17a$var$apply(emit, $e63983a9d029a17a$export$7e019dae5103a285)));
        on([
            $e63983a9d029a17a$export$db40ab7c0855fa5c,
            $e63983a9d029a17a$export$7f4701ac5e05e39f
        ], init);
        on($e63983a9d029a17a$export$7e019dae5103a285, resize);
    };
    var init = function init() {
        vertical = options.direction === $e63983a9d029a17a$export$97170d9824b89709;
        $e63983a9d029a17a$var$style(root, "maxWidth", $e63983a9d029a17a$var$unit(options.width));
        $e63983a9d029a17a$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $e63983a9d029a17a$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    };
    var resize = function resize(force) {
        var newRect = $e63983a9d029a17a$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $e63983a9d029a17a$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $e63983a9d029a17a$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($e63983a9d029a17a$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $e63983a9d029a17a$var$toggleClass(root, $e63983a9d029a17a$export$cd908cd1dd625e29, overflow);
                emit($e63983a9d029a17a$export$6cbac5b662a31e1b, overflow);
            }
        }
    };
    var cssPadding = function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $e63983a9d029a17a$var$unit(padding[prop] || ($e63983a9d029a17a$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    var cssTrackHeight = function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $e63983a9d029a17a$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    };
    var cssHeight = function cssHeight() {
        return $e63983a9d029a17a$var$unit(options.height || $e63983a9d029a17a$var$rect(list).width * options.heightRatio);
    };
    var cssSlideWidth = function cssSlideWidth() {
        return options.autoWidth ? null : $e63983a9d029a17a$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    };
    var cssSlideHeight = function cssSlideHeight() {
        return $e63983a9d029a17a$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    };
    var cssSlideSize = function cssSlideSize() {
        var gap = $e63983a9d029a17a$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    var listSize = function listSize() {
        return $e63983a9d029a17a$var$rect(list)[resolve("width")];
    };
    var slideSize = function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $e63983a9d029a17a$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    };
    var totalSize = function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $e63983a9d029a17a$var$rect(Slide.slide)[resolve("right")];
            var left = $e63983a9d029a17a$var$rect(list)[resolve("left")];
            return $e63983a9d029a17a$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    };
    var sliderSize = function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    };
    var getGap = function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($e63983a9d029a17a$var$style(Slide.slide, resolve("marginRight"))) || 0;
    };
    var getPadding = function getPadding(right) {
        return parseFloat($e63983a9d029a17a$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    };
    var isOverflow = function isOverflow() {
        return Splide2.is($e63983a9d029a17a$export$742b62a5690c060) || sliderSize(true) > listSize();
    };
    var _EventInterface3 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = _$Slides.getAt, styleSlides = _$Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $e63983a9d029a17a$var$MULTIPLIER = 2;
function $e63983a9d029a17a$var$Clones(Splide2, Components2, options) {
    var mount = function mount() {
        on($e63983a9d029a17a$export$7f4701ac5e05e39f, remount);
        on([
            $e63983a9d029a17a$export$db40ab7c0855fa5c,
            $e63983a9d029a17a$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var destroy = function destroy() {
        $e63983a9d029a17a$var$remove(clones);
        $e63983a9d029a17a$var$empty(clones);
        event.destroy();
    };
    var observe = function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($e63983a9d029a17a$export$7f4701ac5e05e39f);
        }
    };
    var generate = function generate(count) {
        var slides = _$Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$e63983a9d029a17a$var$push(slides, slides);
            $e63983a9d029a17a$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $e63983a9d029a17a$var$before(clone, slides[0].slide) : $e63983a9d029a17a$var$append(_$Elements.list, clone);
                $e63983a9d029a17a$var$push(clones, clone);
                _$Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    };
    var cloneDeep = function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $e63983a9d029a17a$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $e63983a9d029a17a$var$pad(index + 1);
        return clone;
    };
    var computeCloneCount = function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($e63983a9d029a17a$export$f42383286ed1223d)) clones2 = 0;
        else if ($e63983a9d029a17a$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $e63983a9d029a17a$var$ceil($e63983a9d029a17a$var$rect(_$Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $e63983a9d029a17a$var$MULTIPLIER;
        }
        return clones2;
    };
    var event = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var _$Elements = Components2.Elements, _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    return {
        mount: mount,
        destroy: destroy
    };
}
function $e63983a9d029a17a$var$Move(Splide2, Components2, options) {
    var mount = function mount() {
        Transition = Components2.Transition;
        on([
            $e63983a9d029a17a$export$d300dc1a2634364b,
            $e63983a9d029a17a$export$d637eba1e9e28482,
            $e63983a9d029a17a$export$db40ab7c0855fa5c,
            $e63983a9d029a17a$export$7f4701ac5e05e39f
        ], reposition);
    };
    var reposition = function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    };
    var move = function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($e63983a9d029a17a$var$MOVING);
        emit($e63983a9d029a17a$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($e63983a9d029a17a$var$IDLE);
            emit($e63983a9d029a17a$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    };
    var jump = function jump(index) {
        translate(toPosition(index, true));
    };
    var translate = function translate(position, preventLoop) {
        if (!Splide2.is($e63983a9d029a17a$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $e63983a9d029a17a$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($e63983a9d029a17a$export$f0af896383d5adff);
        }
    };
    var loop = function loop(position) {
        if (Splide2.is($e63983a9d029a17a$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    };
    var shift = function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($e63983a9d029a17a$var$ceil($e63983a9d029a17a$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    };
    var cancel = function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    };
    var toIndex = function toIndex(position) {
        var _$Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < _$Slides.length; i++){
            var slideIndex = _$Slides[i].index;
            var distance = $e63983a9d029a17a$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    };
    var toPosition = function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    };
    var getPosition = function getPosition() {
        var left = resolve("left");
        return $e63983a9d029a17a$var$rect(list)[left] - $e63983a9d029a17a$var$rect(track)[left] + orient(getPadding(false));
    };
    var trim = function trim(position) {
        if (options.trimSpace && Splide2.is($e63983a9d029a17a$export$e5a58a5ee5b54c22)) position = $e63983a9d029a17a$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    };
    var offset = function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    };
    var getLimit = function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    };
    var canShift = function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $e63983a9d029a17a$var$rect(track)[resolve("width")];
    };
    var exceededLimit = function exceededLimit(max, position) {
        position = $e63983a9d029a17a$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    };
    var _EventInterface4 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $e63983a9d029a17a$var$Controller(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on([
            $e63983a9d029a17a$export$db40ab7c0855fa5c,
            $e63983a9d029a17a$export$7f4701ac5e05e39f,
            $e63983a9d029a17a$export$28dea85f216954dc
        ], init);
        on($e63983a9d029a17a$export$d637eba1e9e28482, onResized);
    };
    var init = function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $e63983a9d029a17a$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            _$Move.reposition();
        }
    };
    var onResized = function onResized() {
        if (endIndex !== getEnd()) emit($e63983a9d029a17a$export$28dea85f216954dc);
    };
    var go = function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                _$Move.move(dest, index, prevIndex, callback);
            }
        }
    };
    var scroll = function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(_$Move.toIndex(getPosition()));
            setIndex(omitEnd ? $e63983a9d029a17a$var$min(index, endIndex) : index);
            callback && callback();
        });
    };
    var parse = function parse(control) {
        var index = currIndex;
        if ($e63983a9d029a17a$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $e63983a9d029a17a$var$clamp(control, 0, endIndex);
        return index;
    };
    var getAdjacent = function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$e63983a9d029a17a$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    };
    var computeDestIndex = function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($e63983a9d029a17a$var$between(0, dest, from, true) || $e63983a9d029a17a$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    };
    var computeMovableDestIndex = function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $e63983a9d029a17a$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    };
    var loop = function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    };
    var getEnd = function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $e63983a9d029a17a$var$clamp(end, 0, slideCount - 1);
    };
    var toIndex = function toIndex(page) {
        return $e63983a9d029a17a$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    };
    var toPage = function toPage(index) {
        return hasFocus() ? $e63983a9d029a17a$var$min(index, endIndex) : $e63983a9d029a17a$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    };
    var toDest = function toDest(destination) {
        var closest = _$Move.toIndex(destination);
        return isSlide ? $e63983a9d029a17a$var$clamp(closest, 0, endIndex) : closest;
    };
    var setIndex = function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    };
    var getIndex = function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    };
    var hasFocus = function hasFocus() {
        return !$e63983a9d029a17a$var$isUndefined(options.focus) || options.isNavigation;
    };
    var isBusy = function isBusy() {
        return Splide2.state.is([
            $e63983a9d029a17a$var$MOVING,
            $e63983a9d029a17a$var$SCROLLING
        ]) && !!options.waitForTransition;
    };
    var _EventInterface5 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, toPosition = _$Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($e63983a9d029a17a$export$f42383286ed1223d);
    var isSlide = Splide2.is($e63983a9d029a17a$export$e5a58a5ee5b54c22);
    var getNext = $e63983a9d029a17a$var$apply(getAdjacent, false);
    var getPrev = $e63983a9d029a17a$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $e63983a9d029a17a$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $e63983a9d029a17a$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $e63983a9d029a17a$var$SIZE = 40;
function $e63983a9d029a17a$var$Arrows(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($e63983a9d029a17a$export$db40ab7c0855fa5c, remount);
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var init = function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $e63983a9d029a17a$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $e63983a9d029a17a$var$display(wrapper, enabled ? "" : "none");
            $e63983a9d029a17a$var$addClass(wrapper, wrapperClasses = $e63983a9d029a17a$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $e63983a9d029a17a$var$setAttribute([
                    prev,
                    next
                ], $e63983a9d029a17a$var$ARIA_CONTROLS, track.id);
                emit($e63983a9d029a17a$export$8647f6b043e04e9d, prev, next);
            }
        }
    };
    var destroy = function destroy() {
        event.destroy();
        $e63983a9d029a17a$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $e63983a9d029a17a$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $e63983a9d029a17a$var$removeAttribute([
            prev,
            next
        ], $e63983a9d029a17a$var$ALL_ATTRIBUTES);
    };
    var listen = function listen() {
        on([
            $e63983a9d029a17a$export$d300dc1a2634364b,
            $e63983a9d029a17a$export$fe5802204b967f0d,
            $e63983a9d029a17a$export$7f4701ac5e05e39f,
            $e63983a9d029a17a$export$ff8164bff3202b9,
            $e63983a9d029a17a$export$28dea85f216954dc
        ], update);
        bind(next, "click", $e63983a9d029a17a$var$apply(go, ">"));
        bind(prev, "click", $e63983a9d029a17a$var$apply(go, "<"));
    };
    var go = function go(control) {
        _$Controller.go(control, true);
    };
    var createArrows = function createArrows() {
        wrapper = placeholder || $e63983a9d029a17a$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $e63983a9d029a17a$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $e63983a9d029a17a$var$before(wrapper, track);
    };
    var createArrow = function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $e63983a9d029a17a$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $e63983a9d029a17a$var$SIZE + " " + $e63983a9d029a17a$var$SIZE + '" width="' + $e63983a9d029a17a$var$SIZE + '" height="' + $e63983a9d029a17a$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $e63983a9d029a17a$var$PATH) + '" />';
        return $e63983a9d029a17a$var$parseHtml(arrow);
    };
    var update = function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = _$Controller.getPrev();
            var nextIndex = _$Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $e63983a9d029a17a$var$setAttribute(prev, $e63983a9d029a17a$var$ARIA_LABEL, prevLabel);
            $e63983a9d029a17a$var$setAttribute(next, $e63983a9d029a17a$var$ARIA_LABEL, nextLabel);
            emit($e63983a9d029a17a$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    };
    var event = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var placeholder = _$Elements.arrows, track = _$Elements.track;
    var wrapper = placeholder;
    var prev = _$Elements.prev;
    var next = _$Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $e63983a9d029a17a$var$INTERVAL_DATA_ATTRIBUTE = $e63983a9d029a17a$var$DATA_ATTRIBUTE + "-interval";
function $e63983a9d029a17a$var$Autoplay(Splide2, Components2, options) {
    var mount = function mount() {
        if (autoplay) {
            listen();
            toggle && $e63983a9d029a17a$var$setAttribute(toggle, $e63983a9d029a17a$var$ARIA_CONTROLS, _$Elements.track.id);
            stopped || play();
            update();
        }
    };
    var listen = function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $e63983a9d029a17a$export$2aa493d7c3275167,
            $e63983a9d029a17a$export$49801896908b5e33,
            $e63983a9d029a17a$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($e63983a9d029a17a$export$2aa493d7c3275167, onMove);
    };
    var play = function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($e63983a9d029a17a$export$23663268a31b79e2);
        }
    };
    var pause = function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($e63983a9d029a17a$export$16a1e4f3d0368265);
        }
    };
    var autoToggle = function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    };
    var update = function update() {
        if (toggle) {
            $e63983a9d029a17a$var$toggleClass(toggle, $e63983a9d029a17a$export$72d36ecf3758cb4b, !stopped);
            $e63983a9d029a17a$var$setAttribute(toggle, $e63983a9d029a17a$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    };
    var onAnimationFrame = function onAnimationFrame(rate) {
        var bar = _$Elements.bar;
        bar && $e63983a9d029a17a$var$style(bar, "width", rate * 100 + "%");
        emit($e63983a9d029a17a$export$185723258309b608, rate);
    };
    var onMove = function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$e63983a9d029a17a$var$getAttribute(Slide.slide, $e63983a9d029a17a$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    };
    var _EventInterface6 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $e63983a9d029a17a$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var _$Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $e63983a9d029a17a$var$Cover(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.cover) {
            on($e63983a9d029a17a$export$9f64346e17f0ec8e, $e63983a9d029a17a$var$apply(toggle, true));
            on([
                $e63983a9d029a17a$export$d300dc1a2634364b,
                $e63983a9d029a17a$export$db40ab7c0855fa5c,
                $e63983a9d029a17a$export$7f4701ac5e05e39f
            ], $e63983a9d029a17a$var$apply(cover, true));
        }
    };
    var cover = function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $e63983a9d029a17a$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    };
    var toggle = function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $e63983a9d029a17a$var$display(img, cover2 ? "none" : "");
    };
    var _EventInterface7 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    return {
        mount: mount,
        destroy: $e63983a9d029a17a$var$apply(cover, false)
    };
}
var $e63983a9d029a17a$var$BOUNCE_DIFF_THRESHOLD = 10;
var $e63983a9d029a17a$var$BOUNCE_DURATION = 600;
var $e63983a9d029a17a$var$FRICTION_FACTOR = 0.6;
var $e63983a9d029a17a$var$BASE_VELOCITY = 1.5;
var $e63983a9d029a17a$var$MIN_DURATION = 800;
function $e63983a9d029a17a$var$Scroll(Splide2, Components2, options) {
    var mount = function mount() {
        on($e63983a9d029a17a$export$2aa493d7c3275167, clear);
        on([
            $e63983a9d029a17a$export$db40ab7c0855fa5c,
            $e63983a9d029a17a$export$7f4701ac5e05e39f
        ], cancel);
    };
    var scroll = function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $e63983a9d029a17a$var$sign(destination) * size * $e63983a9d029a17a$var$floor($e63983a9d029a17a$var$abs(destination) / size) || 0;
            destination = _$Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $e63983a9d029a17a$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $e63983a9d029a17a$var$max($e63983a9d029a17a$var$abs(destination - from) / $e63983a9d029a17a$var$BASE_VELOCITY, $e63983a9d029a17a$var$MIN_DURATION);
        callback = onScrolled;
        interval = $e63983a9d029a17a$export$46ad21b25b6dccf0(duration, onEnd, $e63983a9d029a17a$var$apply(update, from, destination, noConstrain), 1);
        set($e63983a9d029a17a$var$SCROLLING);
        emit($e63983a9d029a17a$export$49801896908b5e33);
        interval.start();
    };
    var onEnd = function onEnd() {
        set($e63983a9d029a17a$var$IDLE);
        callback && callback();
        emit($e63983a9d029a17a$export$ff8164bff3202b9);
    };
    var update = function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $e63983a9d029a17a$var$FRICTION_FACTOR;
            if ($e63983a9d029a17a$var$abs(diff) < $e63983a9d029a17a$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $e63983a9d029a17a$var$BOUNCE_DURATION, false, callback, true);
        }
    };
    var clear = function clear() {
        if (interval) interval.cancel();
    };
    var cancel = function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    };
    var easing = function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    };
    var _EventInterface8 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, exceededLimit = _$Move.exceededLimit, translate = _$Move.translate;
    var isSlide = Splide2.is($e63983a9d029a17a$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $e63983a9d029a17a$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $e63983a9d029a17a$var$Drag(Splide2, Components2, options) {
    var mount = function mount() {
        bind(track, $e63983a9d029a17a$var$POINTER_MOVE_EVENTS, $e63983a9d029a17a$var$noop, $e63983a9d029a17a$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $e63983a9d029a17a$var$POINTER_UP_EVENTS, $e63983a9d029a17a$var$noop, $e63983a9d029a17a$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $e63983a9d029a17a$var$POINTER_DOWN_EVENTS, onPointerDown, $e63983a9d029a17a$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $e63983a9d029a17a$var$prevent);
        on([
            $e63983a9d029a17a$export$d300dc1a2634364b,
            $e63983a9d029a17a$export$db40ab7c0855fa5c
        ], init);
    };
    var init = function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    };
    var onPointerDown = function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!_$Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $e63983a9d029a17a$var$MOVING,
                        $e63983a9d029a17a$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $e63983a9d029a17a$var$POINTER_MOVE_EVENTS, onPointerMove, $e63983a9d029a17a$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $e63983a9d029a17a$var$POINTER_UP_EVENTS, onPointerUp, $e63983a9d029a17a$var$SCROLL_LISTENER_OPTIONS);
                    _$Move.cancel();
                    _$Scroll.cancel();
                    save(e);
                } else $e63983a9d029a17a$var$prevent(e, true);
            }
        }
    };
    var onPointerMove = function onPointerMove(e) {
        if (!state.is($e63983a9d029a17a$var$DRAGGING)) {
            state.set($e63983a9d029a17a$var$DRAGGING);
            emit($e63983a9d029a17a$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                _$Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $e63983a9d029a17a$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($e63983a9d029a17a$export$8e9f636d2c722196);
                $e63983a9d029a17a$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $e63983a9d029a17a$var$prevent(e);
            }
        }
    };
    var onClick = function onClick(e) {
        if (!disabled && clickPrevented) $e63983a9d029a17a$var$prevent(e, true);
    };
    var save = function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    };
    var move = function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) _$Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($e63983a9d029a17a$export$742b62a5690c060)) _$Controller.go(orient($e63983a9d029a17a$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($e63983a9d029a17a$export$e5a58a5ee5b54c22) && exceeded && rewind) _$Controller.go(exceededLimit(true) ? ">" : "<");
        else _$Controller.go(_$Controller.toDest(destination), true);
        reduce(true);
    };
    var shouldStart = function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $e63983a9d029a17a$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $e63983a9d029a17a$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    };
    var isSliderDirection = function isSliderDirection(e) {
        return $e63983a9d029a17a$var$abs(diffCoord(e)) > $e63983a9d029a17a$var$abs(diffCoord(e, true));
    };
    var computeVelocity = function computeVelocity(e) {
        if (Splide2.is($e63983a9d029a17a$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $e63983a9d029a17a$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    };
    var computeDestination = function computeDestination(velocity) {
        return getPosition() + $e63983a9d029a17a$var$sign(velocity) * $e63983a9d029a17a$var$min($e63983a9d029a17a$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    };
    var diffCoord = function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    };
    var diffTime = function diffTime(e) {
        return $e63983a9d029a17a$var$timeOf(e) - $e63983a9d029a17a$var$timeOf(getBaseEvent(e));
    };
    var getBaseEvent = function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    };
    var coordOf = function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    };
    var constrain = function constrain(diff) {
        return diff / (exceeded && Splide2.is($e63983a9d029a17a$export$e5a58a5ee5b54c22) ? $e63983a9d029a17a$var$FRICTION : 1);
    };
    var isDraggable = function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$e63983a9d029a17a$var$matches(target2, "." + $e63983a9d029a17a$export$52f2cca6a5eee805 + ", ." + $e63983a9d029a17a$export$516e7d18e13a2dca) && (!noDrag || !$e63983a9d029a17a$var$matches(target2, noDrag));
    };
    var isTouchEvent = function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    };
    var isDragging = function isDragging() {
        return dragging;
    };
    var disable = function disable(value) {
        disabled = value;
    };
    var _EventInterface9 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var _$Move = Components2.Move, _$Scroll = Components2.Scroll, _$Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = _$Move.getPosition, exceededLimit = _$Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function onPointerUp(e) {
        if (state.is($e63983a9d029a17a$var$DRAGGING)) {
            state.set($e63983a9d029a17a$var$IDLE);
            emit($e63983a9d029a17a$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $e63983a9d029a17a$var$prevent(e);
        }
        unbind(target, $e63983a9d029a17a$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $e63983a9d029a17a$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $e63983a9d029a17a$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $e63983a9d029a17a$var$ARROW_RIGHT,
    Left: $e63983a9d029a17a$var$ARROW_LEFT,
    Up: $e63983a9d029a17a$var$ARROW_UP,
    Down: $e63983a9d029a17a$var$ARROW_DOWN
};
function $e63983a9d029a17a$var$normalizeKey(key) {
    key = $e63983a9d029a17a$var$isString(key) ? key : key.key;
    return $e63983a9d029a17a$var$NORMALIZATION_MAP[key] || key;
}
var $e63983a9d029a17a$var$KEYBOARD_EVENT = "keydown";
function $e63983a9d029a17a$var$Keyboard(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($e63983a9d029a17a$export$db40ab7c0855fa5c, destroy);
        on($e63983a9d029a17a$export$db40ab7c0855fa5c, init);
        on($e63983a9d029a17a$export$2aa493d7c3275167, onMove);
    };
    var init = function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $e63983a9d029a17a$var$KEYBOARD_EVENT, onKeydown);
        }
    };
    var destroy = function destroy() {
        unbind(target, $e63983a9d029a17a$var$KEYBOARD_EVENT);
    };
    var disable = function disable(value) {
        disabled = value;
    };
    var onMove = function onMove() {
        var _disabled = disabled;
        disabled = true;
        $e63983a9d029a17a$var$nextTick(function() {
            disabled = _disabled;
        });
    };
    var onKeydown = function onKeydown(e) {
        if (!disabled) {
            var key = $e63983a9d029a17a$var$normalizeKey(e);
            if (key === resolve($e63983a9d029a17a$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($e63983a9d029a17a$var$ARROW_RIGHT)) Splide2.go(">");
        }
    };
    var _EventInterface10 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $e63983a9d029a17a$var$SRC_DATA_ATTRIBUTE = $e63983a9d029a17a$var$DATA_ATTRIBUTE + "-lazy";
var $e63983a9d029a17a$var$SRCSET_DATA_ATTRIBUTE = $e63983a9d029a17a$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $e63983a9d029a17a$var$IMAGE_SELECTOR = "[" + $e63983a9d029a17a$var$SRC_DATA_ATTRIBUTE + "], [" + $e63983a9d029a17a$var$SRCSET_DATA_ATTRIBUTE + "]";
function $e63983a9d029a17a$var$LazyLoad(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.lazyLoad) {
            init();
            on($e63983a9d029a17a$export$7f4701ac5e05e39f, init);
        }
    };
    var init = function init() {
        $e63983a9d029a17a$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    };
    var register = function register() {
        Components2.Slides.forEach(function(Slide) {
            $e63983a9d029a17a$var$queryAll(Slide.slide, $e63983a9d029a17a$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $e63983a9d029a17a$var$getAttribute(img, $e63983a9d029a17a$var$SRC_DATA_ATTRIBUTE);
                var srcset = $e63983a9d029a17a$var$getAttribute(img, $e63983a9d029a17a$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $e63983a9d029a17a$var$child(parent, "." + className) || $e63983a9d029a17a$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $e63983a9d029a17a$var$display(img, "none");
                }
            });
        });
    };
    var check = function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    };
    var load = function load(data) {
        var img = data[0];
        $e63983a9d029a17a$var$addClass(data[1].slide, $e63983a9d029a17a$export$d22ec4ccb7996ba2);
        bind(img, "load error", $e63983a9d029a17a$var$apply(onLoad, data));
        $e63983a9d029a17a$var$setAttribute(img, "src", $e63983a9d029a17a$var$getAttribute(img, $e63983a9d029a17a$var$SRC_DATA_ATTRIBUTE));
        $e63983a9d029a17a$var$setAttribute(img, "srcset", $e63983a9d029a17a$var$getAttribute(img, $e63983a9d029a17a$var$SRCSET_DATA_ATTRIBUTE));
        $e63983a9d029a17a$var$removeAttribute(img, $e63983a9d029a17a$var$SRC_DATA_ATTRIBUTE);
        $e63983a9d029a17a$var$removeAttribute(img, $e63983a9d029a17a$var$SRCSET_DATA_ATTRIBUTE);
    };
    var onLoad = function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $e63983a9d029a17a$var$removeClass(Slide.slide, $e63983a9d029a17a$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $e63983a9d029a17a$var$remove(data[2]);
            $e63983a9d029a17a$var$display(img, "");
            emit($e63983a9d029a17a$export$9f64346e17f0ec8e, img, Slide);
            emit($e63983a9d029a17a$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    };
    var loadNext = function loadNext() {
        entries.length && load(entries.shift());
    };
    var _EventInterface11 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $e63983a9d029a17a$export$fe5802204b967f0d,
        $e63983a9d029a17a$export$ff8164bff3202b9
    ];
    var entries = [];
    return {
        mount: mount,
        destroy: $e63983a9d029a17a$var$apply($e63983a9d029a17a$var$empty, entries),
        check: check
    };
}
function $e63983a9d029a17a$var$Pagination(Splide2, Components2, options) {
    var destroy = function destroy() {
        if (list) {
            $e63983a9d029a17a$var$remove(placeholder ? $e63983a9d029a17a$var$slice(list.children) : list);
            $e63983a9d029a17a$var$removeClass(list, paginationClasses);
            $e63983a9d029a17a$var$empty(items);
            list = null;
        }
        event.destroy();
    };
    var createPagination = function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? _$Controller.getEnd() + 1 : $e63983a9d029a17a$var$ceil(length / perPage);
        list = placeholder || $e63983a9d029a17a$var$create("ul", classes.pagination, _$Elements.track.parentElement);
        $e63983a9d029a17a$var$addClass(list, paginationClasses = $e63983a9d029a17a$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $e63983a9d029a17a$var$setAttribute(list, $e63983a9d029a17a$var$ROLE, "tablist");
        $e63983a9d029a17a$var$setAttribute(list, $e63983a9d029a17a$var$ARIA_LABEL, i18n.select);
        $e63983a9d029a17a$var$setAttribute(list, $e63983a9d029a17a$var$ARIA_ORIENTATION, getDirection() === $e63983a9d029a17a$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $e63983a9d029a17a$var$create("li", null, list);
            var button = $e63983a9d029a17a$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = _$Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $e63983a9d029a17a$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $e63983a9d029a17a$var$apply(onKeydown, i));
            $e63983a9d029a17a$var$setAttribute(li, $e63983a9d029a17a$var$ROLE, "presentation");
            $e63983a9d029a17a$var$setAttribute(button, $e63983a9d029a17a$var$ROLE, "tab");
            $e63983a9d029a17a$var$setAttribute(button, $e63983a9d029a17a$var$ARIA_CONTROLS, controls.join(" "));
            $e63983a9d029a17a$var$setAttribute(button, $e63983a9d029a17a$var$ARIA_LABEL, $e63983a9d029a17a$var$format(text, i + 1));
            $e63983a9d029a17a$var$setAttribute(button, $e63983a9d029a17a$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    };
    var onClick = function onClick(page) {
        go(">" + page, true);
    };
    var onKeydown = function onKeydown(page, e) {
        var length = items.length;
        var key = $e63983a9d029a17a$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($e63983a9d029a17a$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($e63983a9d029a17a$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $e63983a9d029a17a$var$focus(item.button);
            go(">" + nextPage);
            $e63983a9d029a17a$var$prevent(e, true);
        }
    };
    var getDirection = function getDirection() {
        return options.paginationDirection || options.direction;
    };
    var getAt = function getAt(index) {
        return items[_$Controller.toPage(index)];
    };
    var update = function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $e63983a9d029a17a$var$removeClass(button, $e63983a9d029a17a$export$72d36ecf3758cb4b);
            $e63983a9d029a17a$var$removeAttribute(button, $e63983a9d029a17a$var$ARIA_SELECTED);
            $e63983a9d029a17a$var$setAttribute(button, $e63983a9d029a17a$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $e63983a9d029a17a$var$addClass(_button, $e63983a9d029a17a$export$72d36ecf3758cb4b);
            $e63983a9d029a17a$var$setAttribute(_button, $e63983a9d029a17a$var$ARIA_SELECTED, true);
            $e63983a9d029a17a$var$setAttribute(_button, $e63983a9d029a17a$var$TAB_INDEX, "");
        }
        emit($e63983a9d029a17a$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    };
    var event = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var _$Slides = Components2.Slides, _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var hasFocus = _$Controller.hasFocus, getIndex = _$Controller.getIndex, go = _$Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = _$Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $e63983a9d029a17a$export$db40ab7c0855fa5c,
            $e63983a9d029a17a$export$7f4701ac5e05e39f,
            $e63983a9d029a17a$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $e63983a9d029a17a$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $e63983a9d029a17a$export$2aa493d7c3275167,
                $e63983a9d029a17a$export$49801896908b5e33,
                $e63983a9d029a17a$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($e63983a9d029a17a$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $e63983a9d029a17a$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $e63983a9d029a17a$var$Sync(Splide2, Components2, options) {
    var mount = function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    };
    var destroy = function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $e63983a9d029a17a$var$empty(events);
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var sync = function sync(splide, target) {
        var event = $e63983a9d029a17a$export$f188226459c8a3ff(splide);
        event.on($e63983a9d029a17a$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($e63983a9d029a17a$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    };
    var navigate = function navigate() {
        var event = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($e63983a9d029a17a$export$5adb665701eda1ce, onClick);
        on($e63983a9d029a17a$export$6d5af59619d10e6a, onKeydown);
        on([
            $e63983a9d029a17a$export$d300dc1a2634364b,
            $e63983a9d029a17a$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($e63983a9d029a17a$export$84015c33508f94ec, Splide2.splides);
    };
    var update = function update() {
        $e63983a9d029a17a$var$setAttribute(Components2.Elements.list, $e63983a9d029a17a$var$ARIA_ORIENTATION, options.direction === $e63983a9d029a17a$export$97170d9824b89709 ? "vertical" : "");
    };
    var onClick = function onClick(Slide) {
        Splide2.go(Slide.index);
    };
    var onKeydown = function onKeydown(Slide, e) {
        if ($e63983a9d029a17a$var$includes($e63983a9d029a17a$var$TRIGGER_KEYS, $e63983a9d029a17a$var$normalizeKey(e))) {
            onClick(Slide);
            $e63983a9d029a17a$var$prevent(e);
        }
    };
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    return {
        setup: $e63983a9d029a17a$var$apply(Components2.Media.set, {
            slideFocus: $e63983a9d029a17a$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $e63983a9d029a17a$var$Wheel(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $e63983a9d029a17a$var$SCROLL_LISTENER_OPTIONS);
    };
    var onWheel = function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $e63983a9d029a17a$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($e63983a9d029a17a$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $e63983a9d029a17a$var$prevent(e);
        }
    };
    var shouldPrevent = function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($e63983a9d029a17a$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    };
    var _EventInterface12 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    return {
        mount: mount
    };
}
var $e63983a9d029a17a$var$SR_REMOVAL_DELAY = 90;
function $e63983a9d029a17a$var$Live(Splide2, Components2, options) {
    var mount = function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $e63983a9d029a17a$var$setAttribute(track, $e63983a9d029a17a$var$ARIA_ATOMIC, true);
            sr.textContent = "…";
            on($e63983a9d029a17a$export$23663268a31b79e2, $e63983a9d029a17a$var$apply(disable, true));
            on($e63983a9d029a17a$export$16a1e4f3d0368265, $e63983a9d029a17a$var$apply(disable, false));
            on([
                $e63983a9d029a17a$export$fe5802204b967f0d,
                $e63983a9d029a17a$export$ff8164bff3202b9
            ], $e63983a9d029a17a$var$apply(toggle, true));
        }
    };
    var toggle = function toggle(active) {
        $e63983a9d029a17a$var$setAttribute(track, $e63983a9d029a17a$var$ARIA_BUSY, active);
        if (active) {
            $e63983a9d029a17a$var$append(track, sr);
            interval.start();
        } else {
            $e63983a9d029a17a$var$remove(sr);
            interval.cancel();
        }
    };
    var destroy = function destroy() {
        $e63983a9d029a17a$var$removeAttribute(track, [
            $e63983a9d029a17a$var$ARIA_LIVE,
            $e63983a9d029a17a$var$ARIA_ATOMIC,
            $e63983a9d029a17a$var$ARIA_BUSY
        ]);
        $e63983a9d029a17a$var$remove(sr);
    };
    var disable = function disable(disabled) {
        if (enabled) $e63983a9d029a17a$var$setAttribute(track, $e63983a9d029a17a$var$ARIA_LIVE, disabled ? "off" : "polite");
    };
    var _EventInterface13 = $e63983a9d029a17a$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $e63983a9d029a17a$var$create("span", $e63983a9d029a17a$export$bb78d7c200da8960);
    var interval = $e63983a9d029a17a$export$46ad21b25b6dccf0($e63983a9d029a17a$var$SR_REMOVAL_DELAY, $e63983a9d029a17a$var$apply(toggle, false));
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $e63983a9d029a17a$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $e63983a9d029a17a$var$Media,
    Direction: $e63983a9d029a17a$var$Direction,
    Elements: $e63983a9d029a17a$var$Elements,
    Slides: $e63983a9d029a17a$var$Slides,
    Layout: $e63983a9d029a17a$var$Layout,
    Clones: $e63983a9d029a17a$var$Clones,
    Move: $e63983a9d029a17a$var$Move,
    Controller: $e63983a9d029a17a$var$Controller,
    Arrows: $e63983a9d029a17a$var$Arrows,
    Autoplay: $e63983a9d029a17a$var$Autoplay,
    Cover: $e63983a9d029a17a$var$Cover,
    Scroll: $e63983a9d029a17a$var$Scroll,
    Drag: $e63983a9d029a17a$var$Drag,
    Keyboard: $e63983a9d029a17a$var$Keyboard,
    LazyLoad: $e63983a9d029a17a$var$LazyLoad,
    Pagination: $e63983a9d029a17a$var$Pagination,
    Sync: $e63983a9d029a17a$var$Sync,
    Wheel: $e63983a9d029a17a$var$Wheel,
    Live: $e63983a9d029a17a$var$Live
});
var $e63983a9d029a17a$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $e63983a9d029a17a$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $e63983a9d029a17a$export$ba41d43e4a419565,
    i18n: $e63983a9d029a17a$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $e63983a9d029a17a$var$Fade(Splide2, Components2, options) {
    var mount = function mount() {
        $e63983a9d029a17a$export$f188226459c8a3ff(Splide2).on([
            $e63983a9d029a17a$export$d300dc1a2634364b,
            $e63983a9d029a17a$export$7f4701ac5e05e39f
        ], init);
    };
    var init = function init() {
        _$Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    };
    var start = function start(index, done) {
        _$Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $e63983a9d029a17a$var$nextTick(done);
    };
    var _$Slides = Components2.Slides;
    return {
        mount: mount,
        start: start,
        cancel: $e63983a9d029a17a$var$noop
    };
}
function $e63983a9d029a17a$var$Slide(Splide2, Components2, options) {
    var mount = function mount() {
        $e63983a9d029a17a$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    };
    var start = function start(index, done) {
        var destination = _$Move.toPosition(index, true);
        var position = _$Move.getPosition();
        var speed = getSpeed(index);
        if ($e63983a9d029a17a$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) _$Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                _$Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            _$Move.jump(index);
            done();
        }
    };
    var cancel = function cancel() {
        transition("");
        _$Scroll.cancel();
    };
    var getSpeed = function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($e63983a9d029a17a$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = _$Controller.getIndex(true);
            var end = _$Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    };
    var _$Move = Components2.Move, _$Controller = Components2.Controller, _$Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $e63983a9d029a17a$var$apply($e63983a9d029a17a$var$style, list, "transition");
    var endCallback;
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $e63983a9d029a17a$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $e63983a9d029a17a$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $e63983a9d029a17a$export$7254cc27399e90bd($e63983a9d029a17a$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $e63983a9d029a17a$var$isString(target) ? $e63983a9d029a17a$var$query(document, target) : target;
        $e63983a9d029a17a$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $e63983a9d029a17a$var$merge({
            label: $e63983a9d029a17a$var$getAttribute(root, $e63983a9d029a17a$var$ARIA_LABEL) || "",
            labelledby: $e63983a9d029a17a$var$getAttribute(root, $e63983a9d029a17a$var$ARIA_LABELLEDBY) || ""
        }, $e63983a9d029a17a$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $e63983a9d029a17a$var$merge(options, JSON.parse($e63983a9d029a17a$var$getAttribute(root, $e63983a9d029a17a$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $e63983a9d029a17a$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($e63983a9d029a17a$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $e63983a9d029a17a$var$assert(state.is([
            $e63983a9d029a17a$var$CREATED,
            $e63983a9d029a17a$var$DESTROYED
        ]), "Already mounted!");
        state.set($e63983a9d029a17a$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($e63983a9d029a17a$export$742b62a5690c060) ? $e63983a9d029a17a$var$Fade : $e63983a9d029a17a$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $e63983a9d029a17a$var$assign({}, $e63983a9d029a17a$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $e63983a9d029a17a$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $e63983a9d029a17a$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($e63983a9d029a17a$export$d300dc1a2634364b);
        $e63983a9d029a17a$var$addClass(this.root, $e63983a9d029a17a$export$7761661e2d5b9388);
        state.set($e63983a9d029a17a$var$IDLE);
        this.emit($e63983a9d029a17a$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($e63983a9d029a17a$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($e63983a9d029a17a$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($e63983a9d029a17a$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($e63983a9d029a17a$var$CREATED)) $e63983a9d029a17a$export$f188226459c8a3ff(this).on($e63983a9d029a17a$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $e63983a9d029a17a$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($e63983a9d029a17a$export$88c4cf7419e470cd);
            event.destroy();
            completely && $e63983a9d029a17a$var$empty(this.splides);
            state.set($e63983a9d029a17a$var$DESTROYED);
        }
        return this;
    };
    $e63983a9d029a17a$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $e63983a9d029a17a$export$24494c7438c070bf = $e63983a9d029a17a$var$_Splide;
$e63983a9d029a17a$export$24494c7438c070bf.defaults = {};
$e63983a9d029a17a$export$24494c7438c070bf.STATES = $e63983a9d029a17a$var$STATES;
var $e63983a9d029a17a$var$CLASS_RENDERED = "is-rendered";
var $e63983a9d029a17a$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $e63983a9d029a17a$var$Style = /*#__PURE__*/ function() {
    var Style = function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    };
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $e63983a9d029a17a$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $e63983a9d029a17a$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $e63983a9d029a17a$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    var SplideRenderer = function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $e63983a9d029a17a$var$merge($e63983a9d029a17a$export$f484e977a69c6ba6, defaults || {});
        $e63983a9d029a17a$var$merge($e63983a9d029a17a$var$merge(this.options, $e63983a9d029a17a$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $e63983a9d029a17a$var$assign({}, $e63983a9d029a17a$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $e63983a9d029a17a$var$uniqueId("splide");
        this.Style = new $e63983a9d029a17a$var$Style(this.id, this.options);
        this.Direction = $e63983a9d029a17a$var$Direction(null, null, this.options);
        $e63983a9d029a17a$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    };
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $e63983a9d029a17a$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $e63983a9d029a17a$var$queryAll(root, "." + $e63983a9d029a17a$export$2c1ba4a4f1aa4947);
        on($e63983a9d029a17a$export$d300dc1a2634364b, function() {
            $e63983a9d029a17a$var$remove($e63983a9d029a17a$var$child(root, "style"));
        });
        $e63983a9d029a17a$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $e63983a9d029a17a$var$push(this.slides, this.contents.map(function(content, index) {
            content = $e63983a9d029a17a$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $e63983a9d029a17a$export$72d36ecf3758cb4b : "");
            $e63983a9d029a17a$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $e63983a9d029a17a$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $e63983a9d029a17a$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $e63983a9d029a17a$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $e63983a9d029a17a$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $e63983a9d029a17a$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $e63983a9d029a17a$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $e63983a9d029a17a$var$unit(padding[prop] || ($e63983a9d029a17a$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $e63983a9d029a17a$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $e63983a9d029a17a$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $e63983a9d029a17a$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $e63983a9d029a17a$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $e63983a9d029a17a$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($e63983a9d029a17a$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $e63983a9d029a17a$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $e63983a9d029a17a$var$merge($e63983a9d029a17a$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $e63983a9d029a17a$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $e63983a9d029a17a$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $e63983a9d029a17a$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $e63983a9d029a17a$export$93b21159ad85c843,
            $e63983a9d029a17a$export$93b21159ad85c843 + "--" + options.type,
            $e63983a9d029a17a$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $e63983a9d029a17a$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $e63983a9d029a17a$export$93b21159ad85c843 + "--nav",
            $e63983a9d029a17a$export$72d36ecf3758cb4b,
            !this.config.hidden && $e63983a9d029a17a$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $e63983a9d029a17a$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $e63983a9d029a17a$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $e63983a9d029a17a$var$forOwn(styles, function(value, key) {
            style += " " + $e63983a9d029a17a$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$e63983a9d029a17a$var$push(slides, slides);
        $e63983a9d029a17a$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $e63983a9d029a17a$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $e63983a9d029a17a$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $e63983a9d029a17a$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $e63983a9d029a17a$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $e63983a9d029a17a$var$SIZE + " " + $e63983a9d029a17a$var$SIZE + '" width="' + $e63983a9d029a17a$var$SIZE + '" height="' + $e63983a9d029a17a$var$SIZE + '"><path d="' + (this.options.arrowPath || $e63983a9d029a17a$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


var $4dc2467856a18fd0$exports = {};

!function(e, t) {
    var n, o;
    $4dc2467856a18fd0$exports = t();
}(window, function() {
    return function(e) {
        var t = {};
        function n(o) {
            if (t[o]) return t[o].exports;
            var i = t[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, o) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)n.d(o, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return o;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function t() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            var S = function S(e) {
                var _$t = e.stageIndexes, _$n = e.core.stageManager, o = e.props.sources.length - 1;
                _$n.getPreviousSlideIndex = function() {
                    return 0 === _$t.current ? o : _$t.current - 1;
                }, _$n.getNextSlideIndex = function() {
                    return _$t.current === o ? 0 : _$t.current + 1;
                }, _$n.updateStageIndexes = 0 === o ? function() {} : 1 === o ? function() {
                    0 === _$t.current ? (_$t.next = 1, delete _$t.previous) : (_$t.previous = 0, delete _$t.next);
                } : function() {
                    _$t.previous = _$n.getPreviousSlideIndex(), _$t.next = _$n.getNextSlideIndex();
                }, _$n.i = o <= 2 ? function() {
                    return !0;
                } : function(e) {
                    var _$n = _$t.current;
                    if (0 === _$n && e === o || _$n === o && 0 === e) return !0;
                    var i = _$n - e;
                    return -1 === i || 0 === i || 1 === i;
                };
            };
            var L = function L(e) {
                var _$t, _$n = e.props, o = 0, i = {};
                this.getSourceTypeFromLocalStorageByUrl = function(e) {
                    return _$t[e] ? _$t[e] : r(e);
                }, this.handleReceivedSourceTypeForUrl = function(e, n) {
                    if (!1 === i[n] && (o--, "invalid" !== e ? i[n] = e : delete i[n], 0 === o)) {
                        !function(e, t) {
                            for(var _$n in t)e[_$n] = t[_$n];
                        }(_$t, i);
                        try {
                            localStorage.setItem("fslightbox-types", JSON.stringify(_$t));
                        } catch (e) {}
                    }
                };
                var r = function r(e) {
                    o++, i[e] = !1;
                };
                if (_$n.disableLocalStorage) this.getSourceTypeFromLocalStorageByUrl = function() {}, this.handleReceivedSourceTypeForUrl = function() {};
                else {
                    try {
                        _$t = JSON.parse(localStorage.getItem("fslightbox-types"));
                    } catch (e) {}
                    _$t || (_$t = {}, this.getSourceTypeFromLocalStorageByUrl = r);
                }
            };
            var A = function A(e, t, n, o) {
                var i = e.data, r = e.elements.sources, s = n / o, a = 0;
                this.adjustSize = function() {
                    if ((a = i.maxSourceWidth / s) < i.maxSourceHeight) return n < i.maxSourceWidth && (a = o), c();
                    a = o > i.maxSourceHeight ? i.maxSourceHeight : o, c();
                };
                var c = function c() {
                    r[t].style.width = a * s + "px", r[t].style.height = a + "px";
                };
            };
            var C = function C(e, t) {
                var _$n = this, o = e.collections.sourceSizers, i = e.elements, r = i.sourceAnimationWrappers, s = i.sources, a = e.isl, c = e.resolve;
                function l(e, n) {
                    o[t] = c(A, [
                        t,
                        e,
                        n
                    ]), o[t].adjustSize();
                }
                this.runActions = function(e, o) {
                    a[t] = !0, s[t].classList.add(x), r[t].classList.add(g), r[t].removeChild(r[t].firstChild), l(e, o), _$n.runActions = l;
                };
            };
            var E = function E(e, t) {
                var _$n, o = this, i = e.elements.sources, r = e.props, s = (0, e.resolve)(C, [
                    t
                ]);
                this.handleImageLoad = function(e) {
                    var _$t = e.target, _$n = _$t.naturalWidth, o = _$t.naturalHeight;
                    s.runActions(_$n, o);
                }, this.handleVideoLoad = function(e) {
                    var _$t = e.target, o = _$t.videoWidth, i = _$t.videoHeight;
                    _$n = !0, s.runActions(o, i);
                }, this.handleNotMetaDatedVideoLoad = function() {
                    _$n || o.handleYoutubeLoad();
                }, this.handleYoutubeLoad = function() {
                    var _$e = 1920, _$t = 1080;
                    r.maxYoutubeDimensions && (_$e = r.maxYoutubeDimensions.width, _$t = r.maxYoutubeDimensions.height), s.runActions(_$e, _$t);
                }, this.handleCustomLoad = function() {
                    var _$e = i[t], _$n = _$e.offsetWidth, r = _$e.offsetHeight;
                    _$n && r ? s.runActions(_$n, r) : setTimeout(o.handleCustomLoad);
                };
            };
            var F = function F(e, t, n) {
                var o = e.elements.sources, i = e.props.customClasses, r = i[t] ? i[t] : "";
                o[t].className = n + " " + r;
            };
            var I = function I(e, t) {
                var _$n = e.elements.sources, o = e.props.customAttributes;
                for(var i in o[t])_$n[t].setAttribute(i, o[t][i]);
            };
            var T = function T(e, t) {
                var _$n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props.sources;
                i[t] = document.createElement("img"), F(e, t, y), i[t].src = s[t], i[t].onload = _$n[t].handleImageLoad, I(e, t), r[t].appendChild(i[t]);
            };
            var N = function N(e, t) {
                var _$n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props, a = s.sources, c = s.videosPosters;
                i[t] = document.createElement("video"), F(e, t, y), i[t].src = a[t], i[t].onloadedmetadata = function(e) {
                    _$n[t].handleVideoLoad(e);
                }, i[t].controls = !0, I(e, t), c[t] && (i[t].poster = c[t]);
                var l = document.createElement("source");
                l.src = a[t], i[t].appendChild(l), setTimeout(_$n[t].handleNotMetaDatedVideoLoad, 3e3), r[t].appendChild(i[t]);
            };
            var z = function z(e, t) {
                var _$n = e.collections.sourceLoadHandlers, o = e.elements, r = o.sources, s = o.sourceAnimationWrappers, a = e.props.sources;
                r[t] = document.createElement("iframe"), F(e, t, "".concat(y, " ").concat(i, "youtube-iframe"));
                var c = a[t], l = c.split("?")[1];
                r[t].src = "https://www.youtube.com/embed/".concat(c.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2], "?").concat(l || ""), r[t].allowFullscreen = !0, I(e, t), s[t].appendChild(r[t]), _$n[t].handleYoutubeLoad();
            };
            var P = function P(e, t) {
                var _$n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props.sources;
                i[t] = s[t], F(e, t, "".concat(i[t].className, " ").concat(y)), r[t].appendChild(i[t]), _$n[t].handleCustomLoad();
            };
            var k = function k(e, t) {
                var _$n = e.elements, o = _$n.sources, r = _$n.sourceAnimationWrappers;
                e.props.sources;
                o[t] = document.createElement("div"), o[t].className = "".concat(i, "invalid-file-wrapper ").concat(c), o[t].innerHTML = "Invalid source", r[t].classList.add(g), r[t].removeChild(r[t].firstChild), r[t].appendChild(o[t]);
            };
            var H = function H(e) {
                var _$t = e.collections, _$n = _$t.sourceLoadHandlers, o = _$t.sourcesRenderFunctions, i = e.core.sourceDisplayFacade, r = e.resolve;
                this.runActionsForSourceTypeAndIndex = function(t, s) {
                    var a;
                    switch("invalid" !== t && (_$n[s] = r(E, [
                        s
                    ])), t){
                        case "image":
                            a = T;
                            break;
                        case "video":
                            a = N;
                            break;
                        case "youtube":
                            a = z;
                            break;
                        case "custom":
                            a = P;
                            break;
                        default:
                            a = k;
                    }
                    o[s] = function() {
                        return a(e, s);
                    }, i.displaySourcesWhichShouldBeDisplayed();
                };
            };
            var W = function W() {
                var e, _$t, _$n, o = {
                    isUrlYoutubeOne: function isUrlYoutubeOne(e) {
                        var _$t = document.createElement("a");
                        return _$t.href = e, "www.youtube.com" === _$t.hostname || "youtu.be" === _$t.hostname;
                    },
                    getTypeFromResponseContentType: function getTypeFromResponseContentType(e) {
                        return e.slice(0, e.indexOf("/"));
                    }
                };
                function i() {
                    if (4 !== _$n.readyState) {
                        if (2 === _$n.readyState) {
                            var e;
                            switch(o.getTypeFromResponseContentType(_$n.getResponseHeader("content-type"))){
                                case "image":
                                    e = "image";
                                    break;
                                case "video":
                                    e = "video";
                                    break;
                                default:
                                    e = "invalid";
                            }
                            _$n.onreadystatechange = null, _$n.abort(), _$t(e);
                        }
                    } else _$t("invalid");
                }
                this.setUrlToCheck = function(t) {
                    e = t;
                }, this.getSourceType = function(r) {
                    if (o.isUrlYoutubeOne(e)) return r("youtube");
                    _$t = r, (_$n = new XMLHttpRequest).onreadystatechange = i, _$n.open("GET", e, !0), _$n.send();
                };
            };
            var R = function R(e, t, n) {
                var o = e.props, i = o.types, r = o.type, s = o.sources, a = e.resolve;
                this.getTypeSetByClientForIndex = function(e) {
                    var _$t;
                    return i && i[e] ? _$t = i[e] : r && (_$t = r), _$t;
                }, this.retrieveTypeWithXhrForIndex = function(e) {
                    var o = a(W);
                    o.setUrlToCheck(s[e]), o.getSourceType(function(o) {
                        t.handleReceivedSourceTypeForUrl(o, s[e]), n.runActionsForSourceTypeAndIndex(o, e);
                    });
                };
            };
            var D = function D(e, t) {
                var _$n = e.core.stageManager, o = e.elements, i = o.smw, r = o.sourceWrappersContainer, s = e.props, l = 0, f = document.createElement("div");
                function p(e) {
                    f.style.transform = "translateX(".concat(e + l, "px)"), l = 0;
                }
                function h() {
                    return (1 + s.slideDistance) * innerWidth;
                }
                f.className = "".concat(d, " ").concat(a, " ").concat(c), f.s = function() {
                    f.style.display = "flex";
                }, f.h = function() {
                    f.style.display = "none";
                }, f.a = function() {
                    f.classList.add(u);
                }, f.d = function() {
                    f.classList.remove(u);
                }, f.n = function() {
                    f.style.removeProperty("transform");
                }, f.v = function(e) {
                    return l = e, f;
                }, f.ne = function() {
                    p(-h());
                }, f.z = function() {
                    p(0);
                }, f.p = function() {
                    p(h());
                }, _$n.i(t) || f.h(), i[t] = f, r.appendChild(f), function(e, t) {
                    var _$n = e.elements, o = _$n.smw, i = _$n.sourceAnimationWrappers, r = document.createElement("div"), s = document.createElement("div");
                    s.className = "fslightboxl";
                    for(var a = 0; a < 3; a++){
                        var c = document.createElement("div");
                        s.appendChild(c);
                    }
                    r.appendChild(s), o[t].appendChild(r), i[t] = r;
                }(e, t);
            };
            var O = function O(e, t, n, o) {
                var r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                r.setAttributeNS(null, "width", t), r.setAttributeNS(null, "height", t), r.setAttributeNS(null, "viewBox", n);
                var s = document.createElementNS("http://www.w3.org/2000/svg", "path");
                return s.setAttributeNS(null, "class", "".concat(i, "svg-path")), s.setAttributeNS(null, "d", o), r.appendChild(s), e.appendChild(r), r;
            };
            var M = function M(e, t) {
                var _$n = document.createElement("div");
                return _$n.className = "".concat(i, "toolbar-button ").concat(c), _$n.title = t, e.appendChild(_$n), _$n;
            };
            var j = function j(e, t) {
                var _$n = document.createElement("div");
                _$n.className = "".concat(i, "toolbar"), t.appendChild(_$n), function(e, t) {
                    var _$n = e.componentsServices, o = e.data, i = e.fs, r = "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z", s = M(t);
                    s.title = "Enter fullscreen";
                    var a = O(s, "20px", "0 0 18 18", r);
                    _$n.ofs = function() {
                        o.ifs = !0, s.title = "Exit fullscreen", a.setAttributeNS(null, "width", "24px"), a.setAttributeNS(null, "height", "24px"), a.setAttributeNS(null, "viewBox", "0 0 950 1024"), a.firstChild.setAttributeNS(null, "d", "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z");
                    }, _$n.xfs = function() {
                        o.ifs = !1, s.title = "Enter fullscreen", a.setAttributeNS(null, "width", "20px"), a.setAttributeNS(null, "height", "20px"), a.setAttributeNS(null, "viewBox", "0 0 18 18"), a.firstChild.setAttributeNS(null, "d", r);
                    }, s.onclick = i.t;
                }(e, _$n), function(e, t) {
                    var _$n = M(t, "Close");
                    _$n.onclick = e.core.lightboxCloser.closeLightbox, O(_$n, "20px", "0 0 24 24", "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z");
                }(e, _$n);
            };
            var X = function X(e) {
                var _$t = e.props.sources, _$n = e.elements.container, o = document.createElement("div");
                o.className = "".concat(i, "nav"), _$n.appendChild(o), j(e, o), _$t.length > 1 && function(e, t) {
                    var _$n = e.componentsServices, o = e.props.sources, r = (e.stageIndexes, document.createElement("div"));
                    r.className = "".concat(i, "slide-number-container");
                    var s = document.createElement("div");
                    s.className = c;
                    var a = document.createElement("span");
                    _$n.setSlideNumber = function(e) {
                        return a.innerHTML = e;
                    };
                    var l = document.createElement("span");
                    l.className = "".concat(i, "slash");
                    var u = document.createElement("div");
                    u.innerHTML = o.length, r.appendChild(s), s.appendChild(a), s.appendChild(l), s.appendChild(u), t.appendChild(r), setTimeout(function() {
                        s.offsetWidth > 55 && (r.style.justifyContent = "flex-start");
                    });
                }(e, o);
            };
            var B = function B(e, t, n, o) {
                var i = e.elements.container, r = n.charAt(0).toUpperCase() + n.slice(1), s = document.createElement("div");
                s.className = "".concat(p, " ").concat(p, "-").concat(n), s.title = "".concat(r, " slide"), s.onclick = t, function(e, t) {
                    var _$n = document.createElement("div");
                    _$n.className = "".concat(f, " ").concat(c), O(_$n, "20px", "0 0 20 20", t), e.appendChild(_$n);
                }(s, o), i.appendChild(s);
            };
            var U = function U(e) {
                var _$t = e.core, _$n = _$t.lightboxCloser, o = _$t.slideChangeFacade, i = e.fs;
                this.listener = function(e) {
                    switch(e.key){
                        case "Escape":
                            _$n.closeLightbox();
                            break;
                        case "ArrowLeft":
                            o.changeToPrevious();
                            break;
                        case "ArrowRight":
                            o.changeToNext();
                            break;
                        case "F11":
                            e.preventDefault(), i.t();
                    }
                };
            };
            var q = function q(e) {
                var _$t = e.elements, _$n = e.sourcePointerProps, o = e.stageIndexes;
                function i(e, o) {
                    _$t.smw[e].v(_$n.swipedX)[o]();
                }
                this.runActionsForEvent = function(e) {
                    var r, a, c;
                    _$t.container.contains(_$t.slideSwipingHoverer) || _$t.container.appendChild(_$t.slideSwipingHoverer), r = _$t.container, a = s, (c = r.classList).contains(a) || c.add(a), _$n.swipedX = e.screenX - _$n.downScreenX;
                    var l = o.previous, u = o.next;
                    i(o.current, "z"), void 0 !== l && _$n.swipedX > 0 ? i(l, "ne") : void 0 !== u && _$n.swipedX < 0 && i(u, "p");
                };
            };
            var V = function V(e) {
                var _$t = e.props.sources, _$n = e.resolve, o = e.sourcePointerProps, i = _$n(q);
                1 === _$t.length ? this.listener = function() {
                    o.swipedX = 1;
                } : this.listener = function(e) {
                    o.isPointering && i.runActionsForEvent(e);
                };
            };
            var _ = function _(e) {
                var _$t = e.core.slideIndexChanger, _$n = e.elements.smw, o = e.stageIndexes, i = e.sws;
                function r(e) {
                    var _$t = _$n[o.current];
                    _$t.a(), _$t[e]();
                }
                function s(e, t) {
                    void 0 !== e && (_$n[e].s(), _$n[e][t]());
                }
                this.runPositiveSwipedXActions = function() {
                    var _$e = o.previous;
                    if (void 0 === _$e) r("z");
                    else {
                        r("p");
                        var _$n = o.next;
                        _$t.changeTo(_$e);
                        var a = o.previous;
                        i.d(a), i.b(_$n), r("z"), s(a, "ne");
                    }
                }, this.runNegativeSwipedXActions = function() {
                    var _$e = o.next;
                    if (void 0 === _$e) r("z");
                    else {
                        r("ne");
                        var _$n = o.previous;
                        _$t.changeTo(_$e);
                        var a = o.next;
                        i.d(a), i.b(_$n), r("z"), s(a, "p");
                    }
                };
            };
            var Y = function Y(e, t) {
                e.contains(t) && e.removeChild(t);
            };
            var J = function J(e) {
                var _$t = e.core.lightboxCloser, _$n = e.elements, o = e.resolve, i = e.sourcePointerProps, r = o(_);
                this.runNoSwipeActions = function() {
                    Y(_$n.container, _$n.slideSwipingHoverer), i.isSourceDownEventTarget || _$t.closeLightbox(), i.isPointering = !1;
                }, this.runActions = function() {
                    i.swipedX > 0 ? r.runPositiveSwipedXActions() : r.runNegativeSwipedXActions(), Y(_$n.container, _$n.slideSwipingHoverer), _$n.container.classList.remove(s), i.isPointering = !1;
                };
            };
            var G = function G(e) {
                var _$t = e.resolve, _$n = e.sourcePointerProps, o = _$t(J);
                this.listener = function() {
                    _$n.isPointering && (_$n.swipedX ? o.runActions() : o.runNoSwipeActions());
                };
            };
            var $ = function $(e) {
                var _$t = this, _$n = e.core, o = _$n.eventsDispatcher, i = _$n.globalEventsController, r = _$n.scrollbarRecompensor, s = e.data, a = e.elements, c = e.fs, u = e.props, d = e.sourcePointerProps;
                this.isLightboxFadingOut = !1, this.runActions = function() {
                    _$t.isLightboxFadingOut = !0, a.container.classList.add(v), i.removeListeners(), u.exitFullscreenOnClose && s.ifs && c.x(), setTimeout(function() {
                        _$t.isLightboxFadingOut = !1, d.isPointering = !1, a.container.classList.remove(v), document.documentElement.classList.remove(l), r.removeRecompense(), document.body.removeChild(a.container), o.dispatch("onClose");
                    }, 270);
                };
            };
            var K = function K(e, t) {
                var _$n = e.classList;
                _$n.contains(t) && _$n.remove(t);
            };
            var Q = function Q(e) {
                var _$t, _$n, o;
                _$n = (_$t = e).core.eventsDispatcher, o = _$t.props, _$n.dispatch = function(e) {
                    o[e] && o[e]();
                }, function(e) {
                    var _$t = e.componentsServices, _$n = e.data, o = e.fs, i = [
                        "fullscreenchange",
                        "webkitfullscreenchange",
                        "mozfullscreenchange",
                        "MSFullscreenChange"
                    ];
                    function r(e) {
                        for(var _$t = 0; _$t < i.length; _$t++)document[e](i[_$t], s);
                    }
                    function s() {
                        document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement ? _$t.ofs() : _$t.xfs();
                    }
                    o.o = function() {
                        _$t.ofs();
                        var _$e = document.documentElement;
                        _$e.requestFullscreen ? _$e.requestFullscreen() : _$e.mozRequestFullScreen ? _$e.mozRequestFullScreen() : _$e.webkitRequestFullscreen ? _$e.webkitRequestFullscreen() : _$e.msRequestFullscreen && _$e.msRequestFullscreen();
                    }, o.x = function() {
                        _$t.xfs(), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                    }, o.t = function() {
                        _$n.ifs ? o.x() : o.o();
                    }, o.l = function() {
                        r("addEventListener");
                    }, o.q = function() {
                        r("removeEventListener");
                    };
                }(e), function(e) {
                    var _$t = e.core, _$n = _$t.globalEventsController, o = _$t.windowResizeActioner, i = e.fs, r = e.resolve, s = r(U), a = r(V), c = r(G);
                    _$n.attachListeners = function() {
                        document.addEventListener("pointermove", a.listener), document.addEventListener("pointerup", c.listener), addEventListener("resize", o.runActions), document.addEventListener("keydown", s.listener), i.l();
                    }, _$n.removeListeners = function() {
                        document.removeEventListener("pointermove", a.listener), document.removeEventListener("pointerup", c.listener), removeEventListener("resize", o.runActions), document.removeEventListener("keydown", s.listener), i.q();
                    };
                }(e), function(e) {
                    var _$t = e.core.lightboxCloser, _$n = (0, e.resolve)($);
                    _$t.closeLightbox = function() {
                        _$n.isLightboxFadingOut || _$n.runActions();
                    };
                }(e), function(e) {
                    var _$t = e.data, _$n = e.core.scrollbarRecompensor;
                    function o() {
                        document.body.offsetHeight > innerHeight && (document.body.style.marginRight = _$t.scrollbarWidth + "px");
                    }
                    _$n.addRecompense = function() {
                        "complete" === document.readyState ? o() : addEventListener("load", function() {
                            o(), _$n.addRecompense = o;
                        });
                    }, _$n.removeRecompense = function() {
                        document.body.style.removeProperty("margin-right");
                    };
                }(e), function(e) {
                    var _$t = e.core, _$n = _$t.slideChangeFacade, o = _$t.slideIndexChanger, i = _$t.stageManager;
                    e.props.sources.length > 1 ? (_$n.changeToPrevious = function() {
                        o.jumpTo(i.getPreviousSlideIndex());
                    }, _$n.changeToNext = function() {
                        o.jumpTo(i.getNextSlideIndex());
                    }) : (_$n.changeToPrevious = function() {}, _$n.changeToNext = function() {});
                }(e), function(e) {
                    var _$t = e.componentsServices, _$n = e.core, o = _$n.slideIndexChanger, i = _$n.sourceDisplayFacade, r = _$n.stageManager, s = e.elements, a = s.smw, c = s.sourceAnimationWrappers, l = e.isl, u = e.stageIndexes, d = e.sws;
                    o.changeTo = function(e) {
                        u.current = e, r.updateStageIndexes(), _$t.setSlideNumber(e + 1), i.displaySourcesWhichShouldBeDisplayed();
                    }, o.jumpTo = function(e) {
                        var _$t = u.previous, _$n = u.current, i = u.next, s = l[_$n], f = l[e];
                        o.changeTo(e);
                        for(var p = 0; p < a.length; p++)a[p].d();
                        d.d(_$n), d.c(), requestAnimationFrame(function() {
                            requestAnimationFrame(function() {
                                var _$e = u.previous, o = u.next;
                                function p() {
                                    r.i(_$n) ? _$n === u.previous ? a[_$n].ne() : _$n === u.next && a[_$n].p() : (a[_$n].h(), a[_$n].n());
                                }
                                s && c[_$n].classList.add(m), f && c[u.current].classList.add(h), d.a(), void 0 !== _$e && _$e !== _$n && a[_$e].ne(), a[u.current].n(), void 0 !== o && o !== _$n && a[o].p(), d.b(_$t), d.b(i), l[_$n] ? setTimeout(p, 260) : p();
                            });
                        });
                    };
                }(e), function(e) {
                    var _$t = e.core.sourcesPointerDown, _$n = e.elements, o = _$n.smw, i = _$n.sources, r = e.sourcePointerProps, s = e.stageIndexes;
                    _$t.listener = function(e) {
                        "VIDEO" !== e.target.tagName && e.preventDefault(), r.isPointering = !0, r.downScreenX = e.screenX, r.swipedX = 0;
                        var _$t = i[s.current];
                        _$t && _$t.contains(e.target) ? r.isSourceDownEventTarget = !0 : r.isSourceDownEventTarget = !1;
                        for(var _$n = 0; _$n < o.length; _$n++)o[_$n].d();
                    };
                }(e), function(e) {
                    var _$t = e.collections.sourcesRenderFunctions, _$n = e.core.sourceDisplayFacade, o = e.props, i = e.stageIndexes;
                    function r(e) {
                        _$t[e] && (_$t[e](), delete _$t[e]);
                    }
                    _$n.displaySourcesWhichShouldBeDisplayed = function() {
                        if (o.loadOnlyCurrentSource) r(i.current);
                        else for(var _$e in i)r(i[_$e]);
                    };
                }(e), function(e) {
                    var _$t = e.core.stageManager, _$n = e.elements, o = _$n.smw, i = _$n.sourceAnimationWrappers, r = e.isl, s = e.stageIndexes, a = e.sws;
                    a.a = function() {
                        for(var _$e in s)o[s[_$e]].s();
                    }, a.b = function(e) {
                        void 0 === e || _$t.i(e) || (o[e].h(), o[e].n());
                    }, a.c = function() {
                        for(var _$e in s)a.d(s[_$e]);
                    }, a.d = function(e) {
                        if (r[e]) {
                            var _$t = i[e];
                            K(_$t, g), K(_$t, h), K(_$t, m);
                        }
                    };
                }(e), function(e) {
                    var _$t = e.collections.sourceSizers, _$n = e.core.windowResizeActioner, o = e.data, i = e.elements.smw, r = e.stageIndexes;
                    _$n.runActions = function() {
                        innerWidth < 992 ? o.maxSourceWidth = innerWidth : o.maxSourceWidth = .9 * innerWidth, o.maxSourceHeight = .9 * innerHeight;
                        for(var _$e = 0; _$e < i.length; _$e++)i[_$e].d(), _$t[_$e] && _$t[_$e].adjustSize();
                        var _$n = r.previous, s = r.next;
                        void 0 !== _$n && i[_$n].ne(), void 0 !== s && i[s].p();
                    };
                }(e);
            };
            var Z = function Z(e) {
                var _$t = e.componentsServices, _$n = e.core, o = _$n.eventsDispatcher, r = _$n.globalEventsController, s = _$n.scrollbarRecompensor, c = _$n.sourceDisplayFacade, u = _$n.stageManager, f = _$n.windowResizeActioner, p = e.data, h = e.elements, m = (e.props, e.stageIndexes), v = e.sws;
                function b() {
                    var _$t, _$n;
                    p.i = !0, p.scrollbarWidth = function() {
                        var _$e = document.createElement("div"), _$t = _$e.style, _$n = document.createElement("div");
                        _$t.visibility = "hidden", _$t.width = "100px", _$t.msOverflowStyle = "scrollbar", _$t.overflow = "scroll", _$n.style.width = "100%", document.body.appendChild(_$e);
                        var o = _$e.offsetWidth;
                        _$e.appendChild(_$n);
                        var i = _$n.offsetWidth;
                        return document.body.removeChild(_$e), o - i;
                    }(), Q(e), h.container = document.createElement("div"), h.container.className = "".concat(i, "container ").concat(a, " ").concat(g), function(e) {
                        var _$t = e.elements;
                        _$t.slideSwipingHoverer = document.createElement("div"), _$t.slideSwipingHoverer.className = "".concat(i, "slide-swiping-hoverer ").concat(a, " ").concat(d);
                    }(e), X(e), function(e) {
                        var _$t = e.core.sourcesPointerDown, _$n = e.elements, o = e.props.sources, i = document.createElement("div");
                        i.className = "".concat(d, " ").concat(a), _$n.container.appendChild(i), i.addEventListener("pointerdown", _$t.listener), _$n.sourceWrappersContainer = i;
                        for(var r = 0; r < o.length; r++)D(e, r);
                    }(e), e.props.sources.length > 1 && (_$n = (_$t = e).core.slideChangeFacade, B(_$t, _$n.changeToPrevious, "previous", "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"), B(_$t, _$n.changeToNext, "next", "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z")), function(e) {
                        for(var _$t = e.props.sources, _$n = e.resolve, o = _$n(L), i = _$n(H), r = _$n(R, [
                            o,
                            i
                        ]), s = 0; s < _$t.length; s++)if ("string" == typeof _$t[s]) {
                            var a = r.getTypeSetByClientForIndex(s);
                            if (a) i.runActionsForSourceTypeAndIndex(a, s);
                            else {
                                var c = o.getSourceTypeFromLocalStorageByUrl(_$t[s]);
                                c ? i.runActionsForSourceTypeAndIndex(c, s) : r.retrieveTypeWithXhrForIndex(s);
                            }
                        } else i.runActionsForSourceTypeAndIndex("custom", s);
                    }(e), o.dispatch("onInit");
                }
                e.open = function() {
                    var _$n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = m.previous, a = m.current, d = m.next;
                    m.current = _$n, p.i || S(e), u.updateStageIndexes(), p.i ? (v.c(), v.a(), v.b(i), v.b(a), v.b(d), o.dispatch("onShow")) : b(), c.displaySourcesWhichShouldBeDisplayed(), _$t.setSlideNumber(_$n + 1), document.body.appendChild(h.container), document.documentElement.classList.add(l), s.addRecompense(), r.attachListeners(), f.runActions(), h.smw[m.current].n(), o.dispatch("onOpen");
                };
            };
            var te = function te() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            };
            var oe = function oe(e) {
                return function(e) {
                    if (Array.isArray(e)) return ie(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    if (!e) return;
                    if ("string" == typeof e) return ie(e, t);
                    var _$n = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === _$n && e.constructor && (_$n = e.constructor.name);
                    if ("Map" === _$n || "Set" === _$n) return Array.from(e);
                    if ("Arguments" === _$n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n)) return ie(e, t);
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            };
            var ie = function ie(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var _$n = 0, o = new Array(t); _$n < t; _$n++)o[_$n] = e[_$n];
                return o;
            };
            var re = function re() {
                for(var e = document.getElementsByTagName("a"), _$t = function t(t) {
                    if (!e[t].hasAttribute("data-fslightbox")) return "continue";
                    var _$n = e[t].hasAttribute("data-href") ? e[t].getAttribute("data-href") : e[t].getAttribute("href");
                    if (!_$n) return console.warn('The "data-fslightbox" attribute was set without the "href" attribute.'), "continue";
                    var o = e[t].getAttribute("data-fslightbox");
                    fsLightboxInstances[o] || (fsLightboxInstances[o] = new FsLightbox);
                    var i = null;
                    "#" === _$n.charAt(0) ? (i = document.getElementById(_$n.substring(1)).cloneNode(!0)).removeAttribute("id") : i = _$n, fsLightboxInstances[o].props.sources.push(i), fsLightboxInstances[o].elements.a.push(e[t]);
                    var r = fsLightboxInstances[o].props.sources.length - 1;
                    e[t].onclick = function(e) {
                        e.preventDefault(), fsLightboxInstances[o].open(r);
                    }, d("types", "data-type"), d("videosPosters", "data-video-poster"), d("customClasses", "data-class"), d("customClasses", "data-custom-class");
                    for(var s = [
                        "href",
                        "data-fslightbox",
                        "data-href",
                        "data-type",
                        "data-video-poster",
                        "data-class",
                        "data-custom-class"
                    ], a = e[t].attributes, c = fsLightboxInstances[o].props.customAttributes, l = 0; l < a.length; l++)if (-1 === s.indexOf(a[l].name) && "data-" === a[l].name.substr(0, 5)) {
                        c[r] || (c[r] = {});
                        var u = a[l].name.substr(5);
                        c[r][u] = a[l].value;
                    }
                    function d(n, i) {
                        e[t].hasAttribute(i) && (fsLightboxInstances[o].props[n][r] = e[t].getAttribute(i));
                    }
                }, _$n = 0; _$n < e.length; _$n++)_$t(_$n);
                var o = Object.keys(fsLightboxInstances);
                window.fsLightbox = fsLightboxInstances[o[o.length - 1]];
            };
            n.r(t);
            var o, i = "fslightbox-", r = "".concat(i, "styles"), s = "".concat(i, "cursor-grabbing"), a = "".concat(i, "full-dimension"), c = "".concat(i, "flex-centered"), l = "".concat(i, "open"), u = "".concat(i, "transform-transition"), d = "".concat(i, "absoluted"), f = "".concat(i, "slide-btn"), p = "".concat(f, "-container"), h = "".concat(i, "fade-in"), m = "".concat(i, "fade-out"), g = h + "-strong", v = m + "-strong", b = "".concat(i, "opacity-"), x = "".concat(b, "1"), y = "".concat(i, "source");
            function w(e) {
                return (w = "function" == typeof Symbol && "symbol" == (0, $2ebe0d2e21d2eed1$export$5f0017c582d45a2d)(Symbol.iterator) ? function w(e) {
                    return typeof e === "undefined" ? "undefined" : (0, $2ebe0d2e21d2eed1$export$5f0017c582d45a2d)(e);
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $2ebe0d2e21d2eed1$export$5f0017c582d45a2d)(e);
                })(e);
            }
            "object" === ("undefined" == typeof document ? "undefined" : w(document)) && ((o = document.createElement("style")).className = r, o.appendChild(document.createTextNode(".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);touch-action:pinch-zoom;z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slide-number-container .fslightbox-flex-centered{height:100%}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px}}.fslightbox-slide-btn-container-next{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-container-next{padding-left:30px}}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-right:6px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-invalid-file-wrapper{font-size:22px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-youtube-iframe{border:0}.fslightboxl{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightboxl div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightboxl 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightboxl div:nth-child(1){animation-delay:-.45s}.fslightboxl div:nth-child(2){animation-delay:-.3s}.fslightboxl div:nth-child(3){animation-delay:-.15s}@keyframes fslightboxl{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-source{position:relative;z-index:2;opacity:0}")), document.head.appendChild(o));
            function ee(e, t, n) {
                return (ee = te() ? Reflect.construct.bind() : function ee(e, t, n) {
                    var o = [
                        null
                    ];
                    o.push.apply(o, t);
                    var i = new (Function.bind.apply(e, o));
                    return n && ne(i, n.prototype), i;
                }).apply(null, arguments);
            }
            function ne(e, t) {
                return (ne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function ne(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            window.FsLightbox = function() {
                var e = this;
                this.props = {
                    sources: [],
                    customAttributes: [],
                    customClasses: [],
                    types: [],
                    videosPosters: [],
                    slideDistance: .3
                }, this.data = {
                    isFullscreenOpen: !1,
                    maxSourceWidth: 0,
                    maxSourceHeight: 0,
                    scrollbarWidth: 0
                }, this.isl = [], this.sourcePointerProps = {
                    downScreenX: null,
                    isPointering: !1,
                    isSourceDownEventTarget: !1,
                    swipedX: 0
                }, this.stageIndexes = {}, this.elements = {
                    a: [],
                    container: null,
                    slideSwipingHoverer: null,
                    smw: [],
                    sourceWrappersContainer: null,
                    sources: [],
                    sourceAnimationWrappers: []
                }, this.componentsServices = {
                    setSlideNumber: function setSlideNumber() {}
                }, this.resolve = function(t) {
                    var _$n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    return _$n.unshift(e), ee(t, oe(_$n));
                }, this.collections = {
                    sourceLoadHandlers: [],
                    sourcesRenderFunctions: [],
                    sourceSizers: []
                }, this.core = {
                    eventsDispatcher: {},
                    globalEventsController: {},
                    lightboxCloser: {},
                    lightboxUpdater: {},
                    scrollbarRecompensor: {},
                    slideChangeFacade: {},
                    slideIndexChanger: {},
                    sourcesPointerDown: {},
                    sourceDisplayFacade: {},
                    stageManager: {},
                    windowResizeActioner: {}
                }, this.fs = {}, this.sws = {}, Z(this), this.close = function() {
                    return e.core.lightboxCloser.closeLightbox();
                };
            }, window.fsLightboxInstances = {}, re(), window.refreshFsLightbox = function() {
                for(var e in fsLightboxInstances){
                    var _$t = fsLightboxInstances[e].props;
                    fsLightboxInstances[e] = new FsLightbox, fsLightboxInstances[e].props = _$t, fsLightboxInstances[e].props.sources = [], fsLightboxInstances[e].elements.a = [];
                }
                re();
            };
        }
    ]);
});


window.addEventListener("DOMContentLoaded", function() {
    var videos = document.querySelectorAll("#hero .block .video");
    videos.forEach(function(video) {
        video.currentTime = Math.floor(Math.random() * 28);
        // video.playbackRate = ((Math.floor(Math.random() * 150)/100) + 0.1); //tweak these to round to decimals?
        video.playbackRate = Math.floor(Math.random() * 110) / 100 + 0.25;
        video.play(); //not needed if autoplay inline
    });
    var navigationItems = document.querySelectorAll("#navigation .item .link");
    var currentSection = "null";
    window.addEventListener("scroll", function() {
        if (window.scrollY >= window.innerWidth / 25) document.body.classList.add("scrolled");
        else if (window.scrollY < window.innerWidth / 20) document.body.classList.remove("scrolled");
        if (window.scrollY >= window.innerHeight) document.body.classList.add("fold");
        else if (window.scrollY < window.innerHeight) document.body.classList.remove("fold");
        navigationItems.forEach(function(item) {
            item.classList.remove("active"); //debounce this for when the page is scrolling
        });
        // document.querySelector('#navigation .' + location.hash.substr(1) + ' .link').classList.add('active');
        // console.log(location.hash.substr(1));
        var items = document.querySelectorAll("#main > section, #header");
        items.forEach(function(item) {
            var topDistance = item.getBoundingClientRect().top;
            // if  (topDistance < 30 && distance > -30 && currentHash != hash) {
            if (topDistance < 100 && topDistance > -100) currentSection = item.id;
        });
        document.querySelector("#navigation").classList.add("active");
    });
    var sections = document.querySelectorAll("section:not(#what):not(#approach), #header"); //temporary exclusion of what we do highlights to be per-subsection
    observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.intersectionRatio > 0) entry.target.classList.add("visible");
            else entry.target.classList.remove("visible");
        });
    });
    sections.forEach(function(section) {
        observer.observe(section);
    });
});
$(document).ready(function() {
// $('.owl-carousel').owlCarousel({
//   loop:true,
//   margin:15,
//   autoplay:true,
//   smartSpeed:1000,
//   autoplayTimeout:2000,
//   mouseDrag:true,
//   touchDrag:true,
//   responsive:{
//     0:{items: 1},
//     768:{items:2},
//     980:{items:3}
//   },
// });
});
function $92c8eccfebbdd931$var$startPhotoCarousel() {
    if (document.querySelector(".splide")) {
        var splide_options = {
            perPage: 3,
            perMove: 1,
            rewind: true,
            type: "loop",
            gap: "1vw",
            speed: 1000,
            autoplay: 2000,
            pagination: true,
            arrows: false,
            focus: "center",
            pauseOnHover: true,
            pauseOnFocus: true,
            breakpoints: {
                991: {
                    perPage: 2
                },
                767: {
                    perPage: 1
                }
            }
        };
        var photo_slider = new (0, $e63983a9d029a17a$export$24494c7438c070bf)(".splide", splide_options);
        photo_slider.on("ready", function() {
            try {
                // console.log('slider set up');
                refreshFsLightbox();
            } catch (error) {
                console.log("Lightbox not enabled.");
            }
        });
        photo_slider.on("click", function() {
            var Autoplay = photo_slider.Components.Autoplay;
            Autoplay.pause();
        });
        photo_slider.mount();
    }
}
document.addEventListener("DOMContentLoaded", $92c8eccfebbdd931$var$startPhotoCarousel);
$("#popup").on("click", function() {
    $(".popup").addClass("active");
});
$("#close").on("click", function() {
    $(".popup").removeClass("active");
});
$(".popup-overlay").on("click", function() {
    $(".popup").removeClass("active");
});
$("li.contact a.link").on("click", function() {
    $(".popup").addClass("active");
});
$(".popupjs").on("click", function() {
    $(".popup").addClass("active");
});
$(".burger-menu").on("click", function() {
    $("ul.menu").toggleClass("active");
    $(this).toggleClass("close");
});
$("ul.menu li a.link").on("click", function() {
    $("ul.menu").removeClass("active");
    $(".burger-menu").removeClass("close");
});
$(document).ready(function() {
    $(".menu").onePageNav();
});
$(window).scroll(function() {
    var height = $(window).scrollTop();
    if (height < 980) $("li.item").removeClass("active");
});
$(function() {
    $("main.team-members .type-team img").height($("main.team-members .type-team img").width() * 0.85);
    $(window).resize(function() {
        $("main.team-members .type-team img").height($("main.team-members .type-team img").width() * 0.85);
    });
    if ($("#fixedDiv").length) $(document).scroll(function() {
        var $self = $("#fixedDiv");
        $self.css("margin-top", 0);
        var fixedDivOffset = $self.offset().top + $self.outerHeight(true);
        // if reaches footer
        if (fixedDivOffset > $("#footer").offset().top - 30) $self.css("margin-top", -(fixedDivOffset - $("#footer").offset().top));
        else $self.css("margin-top", "0px");
    });
});

})();
//# sourceMappingURL=script.js.map
